import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Modal,
  DatePicker,
  Col,
  Row,
  Divider,
  Select,
  Checkbox,
  Space,
  Card,
  Typography,
  Radio,
  Drawer,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useStore } from "../../store/store";
import {
  DocTypes,
  EntityTypes,
  OwnerType,
} from "../../constants/commonConstants";
import Fileupload from "../../common/fileupload/fileupload";
import * as supplierService from "../../service/fleet-management/supplierService";
import * as masterDataService from "../../service/masterDataService";
import * as otpService from "../../service/otpService";
import {
  getMinAndMaxLengthForMobileNumber,
  getMobileCountryCodeList,
  validateMobileNumber,
} from "../../util/countryWiseMobileNumberUtils";
import { validateNotEmpty, validateEmail } from "../../util/inputValidateUtils";
import Placepicker from "../../common/placepicker/placepicker";
import * as documentUtility from "../../util/documentThumbUtility";
import {
  checkIsFleetOwner,
  checkIsSTO,
  checkIsTurkeyKazak,
  checkIsCountryPresent,
  checkIsFleetOwnerOrBroker,
  checkIsSTOorBroker,
  checkIsFleetOwnerConverted,
  removeUniquenessCheckForCountry
} from "../../util/constantUtility";
import Notification from "../../service/notification";
import {
  UploadOutlined,
  PlusOutlined,
  DeleteFilled,
  CloseOutlined,
} from "@ant-design/icons";
import ExistsImg from "../../assets/images/exists img.svg";
import DriverGruardImg from "../../assets/images/driver-guard-img.svg";
import * as accountService from ".././../service/accountService";
import "./add-supplier.scss";
import { fetchCountryCodeFromGeo } from "../../util/getGeoCountryCode";

import FleetOwner from "../../../src/assets/images/fleet-owner.svg";
import CircleArrowRight from "../../../src/assets/images/Arrow R.svg";
import IndividualOwner from "../../../src/assets/images/individual-owner.svg";
import AutofillDocUpload from "../login/sign-up/components/autofill-doc-upload";
import DocumentListView from "../login/sign-up/components/document-list-view";
import { ocrCustomFileUploadService } from "../../service/documentService";
import autoFillScanner from "../../assets/images/autofill-scanner.svg";
import OCRFileUpload from "../../common/ocr-file-upload/ocr-file-upload";
import MissingDocModal from "../login/sign-up/components/missing-doc-modal";
import SampleDocumentPreviewModal from "../login/sign-up/components/sample-documents-view";
import fileSearchGif from "../../assets/images/file-search.gif";
import DiscardWarningModal from "../../common/discard-warnig-modal/discard-warning-modal";
import ExistingSupplierSearchList from "./existing-supplier-search-list";
import { toTitleCase } from "../../util/toTitleCase";

const { Text } = Typography;
const format = "DD/MM/YYYY";

const AddSupplier = ({
  isOpen,
  setIsOpen,
  onClose,
  formType,
  setSupplierData,
  refresh,
}) => {
  const { t } = useTranslation();
  const { user, saveUser } = useStore();
  const [addSupplierForm] = Form.useForm();
  console.log("ADD Supplier addSupplierForm", addSupplierForm.getFieldValue());
  const [issuingCountriesListWaiter, setIssuingCountriesListWaiter] =
    useState(false);
  const [nextBtn, setNextBtn] = useState(false);
  const [formValues, setFormValues] = useState({});
  console.log("ADD Supplier formValues", formValues);
  const [nextBtnTwo, setNextBtnTwo] = useState(false);
  const [verifyMobile, setVerifyMobile] = useState(false);
  const [mobileCountryCodeLoader, setMobileCountryCodeLoader] = useState(false);
  const [mobileCountryCodeList, setMobileCountryCodeList] = useState([]);
  const [supplierExist, setSupplierExist] = useState(false);
  const [addFleet, setAddFleet] = useState(false);
  const [driverData, setDriverData] = useState(null);
  const [supplierId, setSupplierId] = useState(null);
  console.log("supplierId", supplierId);
  const [driverDocs, setDriverDocs] = useState();
  const [visaArray, setVisaArray] = useState();
  const [addressDetail, setAddressDetail] = useState({
    address: "",
    latitude: 0,
    longitude: 0,
  });
  const [cityOptions, setCityOptions] = useState([]);
  const [cityOptionsWaiter, setCityOptionsWaiter] = useState(false);
  const [countriesListWaiter, setCountriesListWaiter] = useState(false);
  const [countryOptions, setCountryOptions] = useState();
  const [btnLoader, setBtnLoader] = useState(false);
  const [minMaxMobileNoLength, setMinMaxMobileNoLength] = useState(
    getMinAndMaxLengthForMobileNumber()
  );
  const supplierTypeOptions = [
    {
      value: OwnerType.FLEET_OWNER,
      label: "Fleet Owner",
    },

    {
      value: OwnerType.STO,
      label: "Individual Owner (STO)",
    },
  ];
  const [serviceTypesList, setServiceTypesList] = useState([]);
  console.log("serviceTypesList", serviceTypesList);
  const [frontDocs, setFrontDocs] = useState({});
  const defaultVisaDoc = {
    index: 0,
    documentNumber: "",
    issuingCountry: "",
    expiryDate: "",
    frontDoc: {
      // isInsertUpdate: true,
      isPathSet: true,
      documentPath: "",
      documentPathThumb: "",
      fileName: "",
      // *****  OCR NEW KEY ADDED
      isInsertUpdate: true,
      isOCRDoc: false,
    },
  };
  const [visa, setVisa] = useState([{ ...defaultVisaDoc }]);
  const [ibanNumber, setIbanNumber] = useState([""]);
  const [addExistingSupplierModal, setaddExistingSupplierModal] =
    useState(false);
  const [accountDetails, setAccountDetails] = useState({});
  const [selectedCountry, setSelectedCountry] = useState("");
  const [isCountryCodeInitialized, setIsCountryCodeInitialized] =
    useState(false);

  // NEW AND EXISTING SUPPLIER REQ
  const [supplierTypeSelected, setSupplierTypeSelected] = useState(null);

  // ******************* OCR File Uploads STATES *****************
  const [ownerType, setOwnerType] = useState(null);
  console.log("ADD SUPPLIER ownerType", ownerType);
  const [isRadioGroup, setIsRadioGroup] = useState(null);
  const [isOcrFileUpload, setIsOcrFileUpload] = useState(false);
  const [countryCodeName, setCountryCodeName] = useState("");
  console.log("countryCodeName", countryCodeName);

  const initialUploadState = {
    progress: 0,
    status: "Hold Tight - File is Being Prepared Securely.",
    description: "Please don’t close or refresh the screen",
    started: false,
  };
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [ocrConfirmedFiles, setOcrConfirmedFiles] = useState([]);
  const [ocrParsedData, setOcrParsedData] = useState(null);
  const [ocrLogId, setOcrLogId] = useState("");
  const [isUploadingPopupVisible, setIsUploadingPopupVisible] = useState(false);

  const [uploadState, setUploadState] = useState(initialUploadState);
  // Drawer State
  const [openDrawer, setOpenDrawer] = useState(false);
  const [missingDocModal, setMissingDocModal] = useState(false);

  // Sample Doc Preview Modal states
  const [isSamplePreviewOpen, setSamplePreviewOpen] = useState(false);
  const [sampleType, setSampleType] = useState("");

  // Discard  moadl State
  const [isDiscardModalVisible, setIsDiscardModalVisible] = useState(false);

  const sanitizeSupplierName = (value = "") =>
  value
    .replace(/[^a-zA-Z\s.\-()]/g, "") 
    .replace(/ {2,}/g, " ")          
    .trim();  

  useEffect(() => {
    if (ocrParsedData?.documents?.length) {
      const { documents } = ocrParsedData;

      const vatCertificate = documents.find(
        (doc) => doc.docType === "VAT_CERTIFICATE" && doc.status === true
      );

      const tradeLicenseDoc = documents.find(
        (doc) => doc.docType === "TRADE_LICENSE" && doc.status === true
      );

      const drivingLicenseDoc = documents.find(
        (doc) => doc.docType === "DRIVING_LICENSE" && doc.status === true
      );

      const passportDoc = documents.find(
        (doc) => doc.docType === "PASSPORT" && doc.status === true
      );

      const nationalIdDoc = documents.find(
        (doc) => doc.docType === "NATIONAL_ID" && doc.status === true
      );

      const visaDocs = documents.filter(
        (doc) => doc.docType === "VISA" && doc.status === true
      );

      const name =
        documents.find((doc) => doc.nameInEnglish && doc.status === true)
          ?.nameInEnglish || "";

      if (name) {
         const cleanedName = toTitleCase(sanitizeSupplierName(name));
        setFormValues((prev) => ({
          ...prev,
          supplierName: cleanedName || undefined,
        }));
        addSupplierForm.setFieldsValue({
          supplierName: cleanedName || undefined,
        });
      }

      // VAT_CERTIFICATE DOC
      if (vatCertificate?.docNumber || vatCertificate?.docExpiryDate) {
        const { docNumber, docExpiryDate } = vatCertificate;
        const parsedVatExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;
        setFormValues((prev) => ({
          ...prev,
          vatNumber: docNumber || undefined,
          vatExpiry: parsedVatExpiry,
        }));

        const vatUpload = {
          DocType: vatCertificate.docType || "VATCERTFD",
          EntityId: EntityTypes.SUPPLIER,
          FileName:
            `ActualSupplier/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
              vatCertificate.frontUrl
            )}` || null,
          FileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
              vatCertificate.frontUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(vatCertificate.frontUrl) ||
            null,
          FileURL: vatCertificate.frontUrl || null,
          Status: false,
          docType: vatCertificate.docType || "VATCERTFD",
          fileName:
            `ActualSupplier/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
              vatCertificate.frontUrl
            )}` || null,
          fileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_VATCERTFD${documentUtility.getFileExtension(
              vatCertificate.frontUrl
            )}` || null,
          fileUrl: vatCertificate.frontUrl || null,
          fileThumbUrl:
            documentUtility.getThumbnailImagePath(vatCertificate.frontUrl) ||
            null,
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        addSupplierForm.setFieldsValue({
          vatNumber: docNumber || undefined,
          vatExpiry: parsedVatExpiry,
          vatUpload,
        });
      }

      //   TRADE_LICENSE
      if (tradeLicenseDoc?.docNumber || tradeLicenseDoc?.docExpiryDate) {
        const { docNumber, docExpiryDate } = tradeLicenseDoc;
        const parsedTradeExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;
        setFormValues((prev) => ({
          ...prev,
          tradeLicenseNumber: docNumber || undefined,
          tradeExpiry: parsedTradeExpiry,
        }));

        const licenceUpload = {
          DocType: tradeLicenseDoc.docType || "TRADELICFD",
          EntityId: EntityTypes.SUPPLIER,
          FileName:
            `ActualSupplier/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(
              tradeLicenseDoc.frontUrl
            )}` || null,
          FileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(
              tradeLicenseDoc.frontUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(tradeLicenseDoc.frontUrl) ||
            null,
          FileURL: tradeLicenseDoc.frontUrl || null,
          Status: false,

          docType: tradeLicenseDoc.docType || "TRADELICFD",
          fileName:
            `ActualSupplier/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(
              tradeLicenseDoc.frontUrl
            )}` || null,
          fileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_TRADELICFD${documentUtility.getFileExtension(
              tradeLicenseDoc.frontUrl
            )}` || null,
          fileUrl: tradeLicenseDoc.frontUrl || null,
          fileThumbUrl:
            documentUtility.getThumbnailImagePath(tradeLicenseDoc.frontUrl) ||
            null,

          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        addSupplierForm.setFieldsValue({
          tradeLicenseNumber: docNumber || undefined,
          tradeExpiry: parsedTradeExpiry,
          tradeLicenseUpload: licenceUpload,
        });
      }

      // DRIVING LICENSE
      if (drivingLicenseDoc?.docNumber || drivingLicenseDoc?.docExpiryDate) {
        const { docNumber, docExpiryDate } = drivingLicenseDoc;
        const parsedLicenceExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const frontDoc = {
          DocType: "DRLFD",
          EntityId: EntityTypes.SUPPLIER,
          FileName:
            `ActualSupplier/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.frontUrl
            )}` || null,
          FileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.frontUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(drivingLicenseDoc.frontUrl) ||
            null,
          FileURL: drivingLicenseDoc.frontUrl || null,
          Status: false,
          docType: "DRLFD",
          fileName:
            `ActualSupplier/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.frontUrl
            )}` || null,
          fileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.frontUrl
            )}` || null,
          fileUrl: drivingLicenseDoc.frontUrl || null,
          fileThumbUrl:
            documentUtility.getThumbnailImagePath(drivingLicenseDoc.frontUrl) ||
            null,
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const backDoc = {
          DocType: "DRLBD",
          EntityId: EntityTypes.SUPPLIER,
          FileName:
            `ActualSupplier/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.backUrl
            )}` || null,
          FileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.backUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(drivingLicenseDoc.backUrl) ||
            null,
          FileURL: drivingLicenseDoc.backUrl || null,
          Status: false,
          docType: "DRLBD",
          fileName:
            `ActualSupplier/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.backUrl
            )}` || null,
          fileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_DRLFD${documentUtility.getFileExtension(
              drivingLicenseDoc.backUrl
            )}` || null,
          fileUrl: drivingLicenseDoc.backUrl || null,
          fileThumbUrl:
            documentUtility.getThumbnailImagePath(drivingLicenseDoc.backUrl) ||
            null,
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setFormValues((prev) => ({
          ...prev,
          drivingLicenseNumber: docNumber || undefined,
          licenseExpiry: parsedLicenceExpiry,
        }));
        addSupplierForm.setFieldsValue({
          drivingLicenseNumber: docNumber || undefined,
          licenseExpiry: parsedLicenceExpiry,
          licenceFront: frontDoc,
          licenceBack: backDoc,
        });
      }

      // PASSPORT DOC
      if (passportDoc?.docNumber || passportDoc?.docExpiryDate) {
        const { docNumber, docExpiryDate } = passportDoc;
        const parsedPassportExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const passportFront = {
          DocType: "PASSFD",
          EntityId: EntityTypes.SUPPLIER,
          FileName:
            `ActualSupplier/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.frontUrl
            )}` || null,
          FileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.frontUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(passportDoc.frontUrl) || null,
          FileURL: passportDoc.frontUrl || null,
          Status: false,
          docType: "PASSFD",
          fileName:
            `ActualSupplier/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.frontUrl
            )}` || null,
          fileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.frontUrl
            )}` || null,
          fileUrl: passportDoc.frontUrl || null,
          fileThumbUrl:
            documentUtility.getThumbnailImagePath(passportDoc.frontUrl) || null,
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const passportBack = {
          DocType: "PASSBD",
          EntityId: EntityTypes.SUPPLIER,
          FileName:
            `ActualSupplier/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.backUrl
            )}` || null,
          FileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.backUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(passportDoc.backUrl) || null,
          FileURL: passportDoc.backUrl || null,
          Status: false,
          docType: "PASSBD",
          fileName:
            `ActualSupplier/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.backUrl
            )}` || null,
          fileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_PASSFD${documentUtility.getFileExtension(
              passportDoc.backUrl
            )}` || null,
          fileUrl: passportDoc.backUrl || null,
          fileThumbUrl:
            documentUtility.getThumbnailImagePath(passportDoc.backUrl) || null,
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setFormValues((prev) => ({
          ...prev,
          passportNumber: docNumber || undefined,
          passportExpiry: parsedPassportExpiry,
        }));

        addSupplierForm.setFieldsValue({
          passportNumber: docNumber || undefined,
          passportExpiry: parsedPassportExpiry,
          passportFront,
          passportBack,
        });
      }

      // NATIONAL ID
      if (nationalIdDoc?.docNumber || nationalIdDoc?.docExpiryDate) {
        const { docNumber, docExpiryDate } = nationalIdDoc;
        const parsedNationalIdExpiry = docExpiryDate
          ? dayjs(docExpiryDate, "DD-MM-YYYY").format("DD-MM-YYYY")
          : null;

        const nationalIdFront = {
          DocType: "NIDFD",
          EntityId: EntityTypes.SUPPLIER,
          FileName:
            `ActualSupplier/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.frontUrl
            )}` || null,
          FileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.frontUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(nationalIdDoc.frontUrl) ||
            null,
          FileURL: nationalIdDoc.frontUrl || null,
          Status: false,
          docType: "NIDFD",
          fileName:
            `ActualSupplier/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.frontUrl
            )}` || null,
          fileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.frontUrl
            )}` || null,
          fileUrl: nationalIdDoc.frontUrl || null,
          fileThumbUrl:
            documentUtility.getThumbnailImagePath(nationalIdDoc.frontUrl) ||
            null,
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        const nationalIdBack = {
          DocType: "NIDBD",
          EntityId: EntityTypes.SUPPLIER,
          FileName:
            `ActualSupplier/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.backUrl
            )}` || null,
          FileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.backUrl
            )}` || null,
          FileThumbURL:
            documentUtility.getThumbnailImagePath(nationalIdDoc.backUrl) ||
            null,
          FileURL: nationalIdDoc.backUrl || null,
          Status: false,
          docType: "NIDBD",
          fileName:
            `ActualSupplier/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.backUrl
            )}` || null,
          fileThumbName:
            `ActualSupplier_Thumb/${ocrLogId}_NIDFD${documentUtility.getFileExtension(
              nationalIdDoc.backUrl
            )}` || null,
          fileUrl: nationalIdDoc.backUrl || null,
          fileThumbUrl:
            documentUtility.getThumbnailImagePath(nationalIdDoc.backUrl) ||
            null,
          // isInsertUpdate: true,
          isPathSet: true,
          // *****  OCR NEW KEY ADDED
          isInsertUpdate: false,
          isOCRDoc: true,
        };

        setFormValues((prev) => ({
          ...prev,
          nationalId: docNumber || undefined,
          nationalIdExpiry: parsedNationalIdExpiry,
        }));

        addSupplierForm.setFieldsValue({
          nationalId: docNumber || undefined,
          nationalIdExpiry: parsedNationalIdExpiry,
          nationalIdFront,
          nationalIdBack,
        });
      }

      // VISA
      if (visaDocs.length > 0) {
        const formattedVisas = visaDocs.map((doc, index) => ({
          index,
          documentNumber: doc.docNumber || "",
          issuingCountry: doc.issueCountry || "",

          expiryDate: doc.docExpiryDate
            ? dayjs(doc.docExpiryDate, "DD-MM-YYYY").isValid()
              ? dayjs(doc.docExpiryDate, "DD-MM-YYYY").format("YYYY-MM-DD")
              : doc.docExpiryDate
            : "",

          frontDoc: {
            // isInsertUpdate: true,
            isPathSet: true,
            documentPath: doc.frontUrl || "",
            documentPathThumb:
              documentUtility.getThumbnailImagePath(doc.frontUrl) || "",
            fileName:
              `ActualSupplier/${ocrLogId}_VISA_${index}_${documentUtility.getFileExtension(
                doc.frontUrl
              )}` || "",
            // *****  OCR NEW KEY ADDED
            isInsertUpdate: false,
            isOCRDoc: true,
          },
        }));

        setVisa(formattedVisas);
        addSupplierForm.setFieldsValue({
          visa: formattedVisas,
        });
      }

      // ******** SERVICE TYPE SELECTION ************
      let preSelectedServiceType = [];

      if (passportDoc || visaDocs.length > 0) {
        const crossBorder = serviceTypesList.find(
          (type) => type.serviceTypeName === "CrossBorder"
        );
        if (crossBorder) {
          preSelectedServiceType.push(crossBorder.serviceTypeName);
        }
      } else {
        const domestic = serviceTypesList.find(
          (type) => type.serviceTypeName === "Domestic"
        );
        if (domestic) {
          preSelectedServiceType.push(domestic.serviceTypeName);
        }
      }

      if (preSelectedServiceType.length > 0) {
        setFormValues((prev) => ({
          ...prev,
          serviceType: preSelectedServiceType,
        }));
        addSupplierForm.setFieldsValue({
          serviceType: preSelectedServiceType,
        });
      }
    }
  }, [ocrParsedData]);

  useEffect(() => {
    getCountryMobileCodeMaster();
    getServiceTypes();
    getCountries();
  }, []);

  useEffect(() => {
    const initializeCountryCode = async () => {
      // Fetch browser location country code
      const geoCountryCode = await fetchCountryCodeFromGeo();
      const filteredCountry = mobileCountryCodeList?.find(
        (item) => item.country_code === geoCountryCode
      );

      if (filteredCountry && !addSupplierForm?.getFieldValue("countryCode")) {
        addSupplierForm.setFieldValue(
          "countryCode",
          filteredCountry?.phone_code
        );
        setIsCountryCodeInitialized(true);
      }
    };

    initializeCountryCode();
  }, [mobileCountryCodeList]);

  const getServiceTypes = async () => {
    try {
      const res = await masterDataService.getServicesTypeMaster();
      if (res.status === 200) {
        let filterData = res.data.filter(
          (e) => e.serviceTypeCode === "CB" || e.serviceTypeCode === "DOM"
        );
        setServiceTypesList(filterData);
      }
    } catch (err) {}
  };

  const getCountryMobileCodeMaster = async (countryCode = "") => {
    setMobileCountryCodeLoader(true);
    try {
      const response = await masterDataService.getCountryMobileCodeMaster(
        countryCode,
        true
      );
      if (response.status === 200) {
        setMobileCountryCodeList(getMobileCountryCodeList(response.data, true));
      }
      setMobileCountryCodeLoader(false);
    } catch (error) {
      setMobileCountryCodeLoader(false);
    }
  };

  const handleFormChange = (fieldName, val, option) => {
    console.log(fieldName, val, option, "this");

    addSupplierForm.setFieldValue(fieldName, val);

    setFormValues((prev) => ({
      ...prev,
      [fieldName]: val,
    }));

    if (fieldName == "countryCode") {
      setMinMaxMobileNoLength(getMinAndMaxLengthForMobileNumber(val));
    }
    addSupplierForm.validateFields([fieldName]);
  };

  const handleCountryChange = (value, option) => {
    console.log("handleCountryChange", option);
    // setCountryCodeName(option.)
    addSupplierForm.setFieldsValue({ country: value });
    addSupplierForm.setFieldsValue({ city: null });
  };

  const handleLocationChange = (selectedAddress) => {
    setAddressDetail((prev) => {
      return {
        ...prev,
        address: selectedAddress.address,
        latitude: selectedAddress.lat,
        longitude: selectedAddress.lng,
      };
    });
  };

  const getCityList = (value, index) => {
    setCityOptionsWaiter(true);
    masterDataService
      .getCityMasterByCountry(value)
      .then((response) => {
        setCityOptionsWaiter(false);
        if (response.status === 200) {
          setCityOptions(response.data);
        }
      })
      .catch((error) => {
        setCityOptionsWaiter(false);
        setCityOptions([]);
      });
  };

  const buildPayloadAddSupplier = (values) => {
    console.log(values, "valuesfromsto");
    let payload = {
      name: values.supplierName,
      userRole: values.supplierType,
      serviceTypes: checkIsSTO(values.supplierType) ? values.serviceType : [],
      emailId: values.emailId ? values.emailId : "",
      countryCode: values.countryCode,
      mobileNo: values.mobileNumber,
      city: values.city,
      country: values.country,
      address: {
        location: addressDetail.address,
        latitude: addressDetail.latitude,
        longitude: addressDetail.longitude,
      },
    };
    return payload;
  };

  const onSubmitHandler = () => {
    const currentValues = addSupplierForm.getFieldsValue();
    // const mergedValues = { ...formValues, ...currentValues };

    if (nextBtn) {
      //setFormValues(mergedValues);
      addSupplierForm
        .validateFields()
        .then(() => {
          setBtnLoader(true);
          const payload = buildPayloadAddSupplier(currentValues);
          supplierService
            .OnboardingNewSupplier(payload)
            .then((res) => {
              if (res?.data?.status == 200) {
                setSupplierId(res?.data?.data);

                Notification.success(
                  t("SUCCESS_KEY"),
                  t("SUPPLIER_ADDED_SUCCESS")
                );
                setNextBtnTwo(true);
                setBtnLoader(false);
                setNextBtn(false);
                setSupplierData([]);
                //onClose();
                refresh();
              }
            })
            .catch((error) => {
              setBtnLoader(false);
            });
        })
        .catch((error) => {
          setBtnLoader(false);
        });
    } else if (nextBtnTwo) {
      setBtnLoader(true);
      addSupplierForm
        .validateFields()
        .then(() => {
          let payload;
          const values = addSupplierForm.getFieldsValue();
          if (checkIsFleetOwnerOrBroker(formValues?.supplierType)) {
            if (checkIsTurkeyKazak(formValues?.country)) {
              if (formValues?.country === "Kazakhstan") {
                payload = {
                  ocrLogId: ocrLogId || "", // New KEY OCR
                  supplierId: supplierId,
                  tradeLicense: {
                    documentNumber: values?.tradeLicenseNumber,
                    expiryDate: values?.tradeExpiry
                      ? moment(values?.tradeExpiry, format).format("YYYY-MM-DD")
                      : null,
                    frontDoc: {
                      // isInsertUpdate: true,
                      documentPath: values?.tradeLicenseUpload?.fileUrl,
                      documentPathThumb:
                        values?.tradeLicenseUpload?.fileThumbUrl,
                      fileName: values?.tradeLicenseUpload?.fileName,
                      isPathSet: true,
                      // *****  OCR NEW KEY ADDED
                      isInsertUpdate:
                        values?.tradeLicenseUpload?.isInsertUpdate || false,
                      isOCRDoc: values?.tradeLicenseUpload?.isOCRDoc,
                    },
                  },
                  certification: [values?.certification],
                  iBanNo: ibanNumber,
                  registrationOffice: values?.registrationOffice,
                };
              } else {
                payload = {
                  ocrLogId: ocrLogId || "", // New KEY OCR
                  supplierId: supplierId,
                  vatCertificate: {
                    documentNumber: values?.vatNumber,
                    expiryDate: moment(values?.vatExpiry, "DD/MM/YYYY").format(
                      "YYYY-MM-DD"
                    ),
                    // issueDate:"",
                    frontDoc: {
                      // isInsertUpdate: true,
                      documentPath: values?.vatUpload?.fileUrl,
                      documentPathThumb: values?.vatUpload?.fileThumbUrl,
                      fileName: values?.vatUpload?.fileName,
                      isPathSet: true,
                      // *****  OCR NEW KEY ADDED
                      isInsertUpdate:
                        values?.vatUpload?.isInsertUpdate || false,
                      isOCRDoc: values?.vatUpload?.isOCRDoc,
                    },
                  },
                  certification: [values?.certification],
                  iBanNo: ibanNumber,
                  registrationOffice: values?.registrationOffice,
                };
              }
            } else {
              payload = {
                ocrLogId: ocrLogId || "", // New KEY OCR
                supplierId: supplierId ? supplierId : "",
                vatCertificate: {
                  documentNumber: values?.vatNumber,
                  expiryDate: values?.vatExpiry
                    ? moment(values?.vatExpiry, format).format("YYYY-MM-DD")
                    : null,
                  // issueDate:"",
                  frontDoc: {
                    // isInsertUpdate: true,
                    documentPath: values?.vatUpload?.fileUrl,
                    documentPathThumb: values?.vatUpload?.fileThumbUrl,
                    fileName: values?.vatUpload?.fileName,
                    isPathSet: true,
                    // *****  OCR NEW KEY ADDED
                    isInsertUpdate: values?.vatUpload?.isInsertUpdate || false,
                    isOCRDoc: values?.vatUpload?.isOCRDoc,
                  },
                },
                tradeLicense: {
                  documentNumber: values?.tradeLicenseNumber,
                  expiryDate: values?.tradeExpiry
                    ? moment(values?.tradeExpiry, format).format("YYYY-MM-DD")
                    : null,
                  frontDoc: {
                    // isInsertUpdate: true,
                    documentPath: values?.tradeLicenseUpload?.fileUrl,
                    documentPathThumb: values?.tradeLicenseUpload?.fileThumbUrl,
                    fileName: values?.tradeLicenseUpload?.fileName,
                    isPathSet: true,
                    // *****  OCR NEW KEY ADDED
                    isInsertUpdate:
                      values?.tradeLicenseUpload?.isInsertUpdate || false,
                    isOCRDoc: values?.tradeLicenseUpload?.isOCRDoc,
                  },
                },
              };
            }
          } else {
            const hasAnyFilledFields = (visaObj) => {
              return (
                (visaObj?.documentNumber &&
                  visaObj.documentNumber.trim() !== "") ||
                (visaObj?.issuingCountry &&
                  visaObj.issuingCountry.trim() !== "") ||
                (visaObj?.expiryDate && visaObj.expiryDate.trim() !== "") ||
                (visaObj?.frontDoc?.fileName &&
                  visaObj.frontDoc.fileName.trim() !== "") ||
                (visaObj?.frontDoc?.documentPath &&
                  visaObj.frontDoc.documentPath.trim() !== "")
              );
            };
            let formattedVisa =
              visa
                ?.map((val) => ({
                  ...val,
                  documentNumber: val?.documentNumber
                    ? val.documentNumber
                    : null,
                  frontDoc: {
                    ...val?.frontDoc,
                    isInsertUpdate: val?.frontDoc?.fileName
                      ? val?.frontDoc?.isInsertUpdate
                      : false,
                  },
                  expiryDate: val?.expiryDate
                    ? moment(val?.expiryDate, format, true).isValid()
                      ? moment(val?.expiryDate, format).format("YYYY-MM-DD")
                      : moment(val?.expiryDate).format("YYYY-MM-DD")
                    : null,
                }))
                .filter(hasAnyFilledFields) || [];
            payload = {
              ocrLogId: ocrLogId || "", // New KEY OCR
              supplierId: supplierId ? supplierId : "",
              driverLicense: {
                documentNumber: values.drivingLicenseNumber,
                expiryDate: moment(values.licenseExpiry, format).format(
                  "YYYY-MM-DD"
                ),
                frontDoc: {
                  // isInsertUpdate: true,
                  isPathSet: true,
                  documentPath: values.licenceFront?.fileUrl,
                  documentPathThumb: values.licenceFront?.fileThumbUrl,
                  fileName: values.licenceFront.fileName,
                  // *****  OCR NEW KEY ADDED
                  isInsertUpdate: values?.licenceFront?.isInsertUpdate || false,
                  isOCRDoc: values?.licenceFront?.isOCRDoc,
                },
                backDoc: {
                  // isInsertUpdate: true,
                  isPathSet: true,
                  documentPath: values.licenceBack?.fileUrl,
                  documentPathThumb: values.licenceBack?.fileThumbUrl,
                  fileName: values.licenceBack.fileName,
                  // *****  OCR NEW KEY ADDED
                  isInsertUpdate: values?.licenceBack?.isInsertUpdate || false,
                  isOCRDoc: values?.licenceBack?.isOCRDoc,
                },
              },
              nationalID: {
                documentNumber: values.nationalId,
                expiryDate: moment(values.nationalIdExpiry, format).format(
                  "YYYY-MM-DD"
                ),
                frontDoc: {
                  // isInsertUpdate: true,
                  isPathSet: true,
                  documentPath: values.nationalIdFront?.fileUrl,
                  documentPathThumb: values.nationalIdFront?.fileThumbUrl,
                  fileName: values.nationalIdFront.fileName,
                  // *****  OCR NEW KEY ADDED
                  isInsertUpdate:
                    values?.nationalIdFront?.isInsertUpdate || false,
                  isOCRDoc: values?.nationalIdFront?.isOCRDoc,
                },
                backDoc: {
                  // isInsertUpdate: true,
                  isPathSet: true,
                  documentPath: values.nationalIdBack?.fileUrl,
                  documentPathThumb: values.nationalIdBack?.fileThumbUrl,
                  fileName: values.nationalIdBack.fileName,
                  // *****  OCR NEW KEY ADDED
                  isInsertUpdate:
                    values?.nationalIdBack?.isInsertUpdate || false,
                  isOCRDoc: values?.nationalIdBack?.isOCRDoc,
                },
              },
            };

            if (
              formValues?.serviceType?.length > 0 &&
              formValues?.serviceType?.includes("Domestic") &&
              formValues?.serviceType?.length === 1
            ) {
            } else {
              payload = {
                ...payload,

                passport: {
                  documentNumber: values.passportNumber
                    ? values.passportNumber
                    : "",
                  expiryDate: moment(values.passportExpiry, format).format(
                    "YYYY-MM-DD"
                  )
                    ? moment(values.passportExpiry, format).format("YYYY-MM-DD")
                    : "",
                  frontDoc: {
                    // isInsertUpdate: true,
                    isPathSet: true,
                    documentPath: values.passportFront?.fileUrl
                      ? values.passportFront?.fileUrl
                      : "",
                    documentPathThumb: values.passportFront?.fileThumbUrl
                      ? values.passportFront?.fileThumbUrl
                      : "",
                    fileName: values.passportFront?.fileName
                      ? values.passportFront?.fileName
                      : "",
                    // *****  OCR NEW KEY ADDED
                    isInsertUpdate:
                      values?.passportFront?.isInsertUpdate || false,
                    isOCRDoc: values?.passportFront?.isOCRDoc,
                  },
                  backDoc: {
                    // isInsertUpdate: true,
                    isPathSet: true,
                    documentPath: values.passportBack?.fileUrl
                      ? values.passportBack?.fileUrl
                      : "",
                    documentPathThumb: values.passportBack?.fileThumbUrl
                      ? values.passportBack?.fileThumbUrl
                      : "",
                    fileName: values.passportBack?.fileName
                      ? values.passportBack?.fileName
                      : "",
                    // *****  OCR NEW KEY ADDED
                    isInsertUpdate:
                      values?.passportBack?.isInsertUpdate || false,
                    isOCRDoc: values?.passportBack?.isOCRDoc,
                  },
                },
                visa: formattedVisa,
              };
            }
          }

          supplierService
            .addSupplierKyc(payload)
            .then((response) => {
              if (response?.status === 200) {
                setBtnLoader(false);
                setNextBtnTwo(false);
                setSupplierData([]);
                onClose();
                refresh();
                Notification.success(
                  t("KYC_DETAIL_KEY"),
                  t("KYC_DETAILS_SUCCESS")
                );
              }
            })
            .catch((error) => {
              setBtnLoader(false);
            });
        })
        .catch(() => {
          setBtnLoader(false);
          Notification.error(t("ERROR_KEY"), t("FILL_MANDATORY_ERROR"));
        });
    } else {
      const values = addSupplierForm.getFieldsValue();
      addSupplierForm
        .validateFields()
        .then(() => {
          const countryFilter = mobileCountryCodeList.find(
            (item) => item.phone_code === values?.countryCode
          );
          // if (checkIsAllowToAddNewSupplier(countryFilter.name)) {
          const payload = {
            countryCode: values?.countryCode,
            mobileNumber: values?.mobileNumber,
            // supplierId :values?.supplierId,
          };
          setBtnLoader(true);
          supplierService
            .CheckSupplierExistanceByInternalSourcer(
              payload.countryCode,
              payload.mobileNumber
            )
            .then((response) => {
              // const countryFilter = mobileCountryCodeList.find((item) => item.phone_code === values?.countryCode)
              // const findCountryCode = countryOptions.find((item)=>item.name === countryFilter.name)
              addSupplierForm.setFieldsValue({
                country: countryFilter.name,
                mobileNumber: values.mobileNumber,
              });
              setFormValues((prev) => ({
                ...prev,
                country: countryFilter.name,
              }));
              getCityList(countryFilter?.country_code);
              setVerifyMobile(true);

              if (
                response?.status == 200 &&
                response?.data?.data?.isExistsInFleet === false &&
                response?.data?.data?.supplierId !== null
              ) {
                setSupplierExist(true);
                setSupplierId(response?.data?.data?.supplierId);

                setBtnLoader(false);
              } else if (
                response?.status == 200 &&
                response?.data?.data?.isExistsInFleet === false &&
                response?.data?.data?.supplierId === null
              ) {
                // setNextBtn(true);
                setBtnLoader(false);
                // OCR step included here
                setIsOcrFileUpload(true);
              } else {
                setBtnLoader(false);
                Notification.error(t("ERROR_KEY"), t("SUPPLIER_EXIST_ERROR"));
                //setIsOpen(false)
              }
              // else if(response?.data?.data?.isExistsInFleet === true){
              //     setBtnLoader(false);

              //     Notification.error("error","Supplier already exist in fleet");
              //     setIsOpen(false)

              // }
            })
            .catch((err) => {
              setBtnLoader(false);
              onClose();
            });
          // }
          // else {
          //     Notification.error("Error", "Can not allow to add " + countryFilter.name+"'s supplier")
          // }
        })
        .catch((error) => {
          addSupplierForm.scrollToField(error.errorFields[0].name[0]);
        });
    }
  };
  const getCountries = () => {
    setCountriesListWaiter(true);
    masterDataService
      .getCountryMaster()
      .then((res) => {
        setCountriesListWaiter(false);
        if (res.status === 200) {
          setCountryOptions(res.data);
          let countries = [];
          user?.dataProtectionDetail?.country?.forEach((ele) => {
            countries.push(ele);
          });
          user?.dataProtectionDetail?.externalShipperMasterIds?.forEach(
            (ele) => {
              if (!countries?.includes(ele.country)) {
                countries.push(ele.country);
              }
            }
          );
          let localCountries = res.data.filter(
            (ele) => countries?.indexOf(ele.name) !== -1
          );
          // setCountries(localCountries);
        }
      })
      .catch((err) => {
        setCountriesListWaiter(false);
      });
  };
  const onFileUploadDocs = (file, fieldName) => {
    var updatedInquiryDocs = { ...frontDocs };
    updatedInquiryDocs = {
      docType: file.DocType,
      fileName: file.FileName,
      fileThumbName: file.FileThumbName,
      fileUrl: file.FileURL,
      size: file.size,
      fileThumbUrl: file.FileThumbURL,
      fileData: file.fileData,
    };

    setFrontDocs(updatedInquiryDocs);
    addSupplierForm.setFieldsValue({
      [fieldName]: {
        docType: file.DocType,
        fileName: file.FileName,
        fileThumbName: file.FileThumbName,
        fileUrl: file.FileURL,
        size: file.size,
        // isInsertUpdate: true,
        isPathSet: true,
        fileThumbUrl: file.FileThumbURL,
        // *****  OCR NEW KEY ADDED
        isInsertUpdate: true,
        isOCRDoc: false,
      },
    });
  };

  const disablePastDates = (current) => {
    return current && current <= dayjs().endOf("day");
  };

  const handleVisa = (val, index) => {
    const tempList = [...visa];
    tempList[index] = {
      ...tempList[index],
      // frontDoc: {
      //   ...tempList[index].frontDoc,
      //   fileName: val.FileName || tempList[index].frontDoc.fileName,
      //   documentPath: val.FileURL || tempList[index].frontDoc.documentPath,
      //   documentPathThumb:
      //     val.FileThumbURL || tempList[index].frontDoc.documentPathThumb,
      //     isInsertUpdate:true,
      //     isPathSet:true
      // },
      documentNumber: val.documentNumber!==undefined ? val.documentNumber :  tempList[index]?.documentNumber,
      issuingCountry: val.issuingCountry || tempList[index]?.issuingCountry,
      expiryDate: val?.expiryDate
        ? moment(val?.expiryDate, format).format("YYYY-MM-DD")
        : null || tempList[index]?.expiryDate,
    };
    setVisa(tempList);
    handleFormChange("visa", tempList);
  };

  // const handleVisaIssuingCountryChange = (val, index) => {

  //     let tempList = [...visa];
  //     tempList[index].
  //  = val;

  //     setVisa(tempList);
  // }

  const handleVisaDocumentChange = (val, index) => {
    let tempList = [...visa];
    tempList[index].frontDoc = {
      fileName: val.FileName,
      documentPath: val.FileURL,
      documentPathThumb: val.FileThumbURL,
      isInsertUpdate: true,
      isPathSet: true,
      // *****  OCR NEW KEY ADDED
      isOCRDoc: false,
    };

    setVisa(tempList);
  };

  const addVisa = () => {
    setVisa([...visa, { ...defaultVisaDoc, index: visa?.length }]);
  };

  const handleIbanNumberChange = (val, index) => {
    // Update the IBAN array
    let updatedIbans = [...ibanNumber];
    updatedIbans[index] = val;
    setIbanNumber(updatedIbans);
    const vatNumber = addSupplierForm.getFieldValue("vatNumber");
    // Validate IBANs
    const errors = updatedIbans
      .map((iban, idx) => {
        let fieldErrors = [];
        // Validation 1: IBAN must not match the VAT number
        if (iban === vatNumber) {
          fieldErrors.push("VAT and IBAN number cannot be the same");
        }
        // Validation 2: IBAN numbers must be unique
        if (updatedIbans.filter((item) => item === iban).length > 1) {
          fieldErrors.push("IBAN numbers must be unique");
        }
        return fieldErrors.length
          ? { name: `vatRegistration_${idx}`, errors: fieldErrors }
          : null;
      })
      .filter(Boolean); // Remove null values
    addSupplierForm.setFields(errors);
    // Update the value if no errors for the current field
    if (!errors.find((error) => error.name === `vatRegistration_${index}`)) {
      addSupplierForm.setFieldsValue({ [`vatRegistration_${index}`]: val });
    }
  };

  const addIbanNumber = () => {
    let temp = [...ibanNumber];
    temp.push("");
    setIbanNumber(temp);
  };

  //  EXISTING SUPPLIER CHECK
  const checkSupplierExistence = async (countryCode, mobileNumber) => {
    if (!countryCode || !mobileNumber) {
      Notification.error(
        t("ERROR_KEY"),
        "Missing country code or mobile number"
      );
      return;
    }
    setBtnLoader(true);
    try {
      const response =
        await supplierService.CheckSupplierExistanceByInternalSourcer(
          countryCode,
          mobileNumber
        );

      if (
        response?.status === 200 &&
        response?.data?.data?.isExistsInFleet === false &&
        response?.data?.data?.supplierId !== null
      ) {
        const supplierIdFromApi = response.data.data.supplierId;
        setSupplierExist(true);
        setSupplierId(supplierIdFromApi);
        addExistingSupplierFunction(supplierIdFromApi);
      } else {
        Notification.error(t("ERROR_KEY"), t("SUPPLIER_EXIST_ERROR"));
      }
    } catch (err) {
      onClose();
    } finally {
      setBtnLoader(false);
    }
  };

  const addExistingSupplierFunction = (existingId) => {
    const accountId = existingId ? existingId : supplierId;

    supplierService
      // .getAccountDetails(supplierId)
      .getAccountDetails(accountId)
      .then((response) => {
        setBtnLoader(false);
        setAccountDetails(response?.data?.data);
        // fillUserDetail(response);
        console.log(accountDetails, "account");
      });
    supplierService
      // .getSupplierKycInfo(supplierId)
      .getSupplierKycInfo(accountId)
      .then((response) => {
        setDriverDocs(response?.data?.data);
        setVisaArray(response?.data?.data?.visa);
      })

      .catch((error) => {
        setBtnLoader(false);
      });

    setaddExistingSupplierModal(true);
  };

  const handleAddSupplier = () => {
    supplierService
      .AddSupplierInFleet({ externalSupplierId: supplierId })
      .then((response) => {
        // console.log(response)
        setaddExistingSupplierModal(false);
        setIsOpen(false);
        // Notification.success(t("SUCCESS_KEY"), t("DRIVING_ADDED_TO_FLEET"));

        if (response?.data?.data.isAlreadyExistsInFleet === true) {
          Notification.error(t("ERROR_KEY"), t("SUPPLIER_EXIST_ERROR"));
        } else {
          Notification.success(t("SUCCESS_KEY"), t("SUPPLIER_ADDED_SUCCESS"));
        }
      });
  };

  const isTurkeyKazakhstanPresent =
    accountDetails?.operatingCountry === "Turkey" ||
    accountDetails?.operatingCountry === "Kazakhstan" ||
    !checkIsCountryPresent(accountDetails?.operatingCountry);

  const checkIsDisabledToAddSupplier = () => {
    debugger;
    if (
      (user.operatingCountry === "Turkey" ||
        user.operatingCountry === "Kazakhstan") &&
      !(
        accountDetails?.operatingCountry === "Turkey" ||
        accountDetails?.operatingCountry === "Kazakhstan" ||
        !accountDetails?.operatingCountry
      )
    ) {
      return true;
    } else if (
      !(
        user.operatingCountry === "Turkey" ||
        user.operatingCountry === "Kazakhstan"
      ) &&
      (accountDetails?.operatingCountry === "Turkey" ||
        accountDetails?.operatingCountry === "Kazakhstan" ||
        !accountDetails?.operatingCountry)
    ) {
      return true;
    }
    return false;
  };
  const checkIsAllowToAddNewSupplier = (country) => {
    debugger;
    if (
      (user.operatingCountry === "Turkey" ||
        user.operatingCountry === "Kazakhstan") &&
      checkIsCountryPresent(country?.toLowerCase())
    ) {
      return false;
    } else if (
      !(
        user.operatingCountry === "Turkey" ||
        user.operatingCountry === "Kazakhstan"
      )
    ) {
      if (!checkIsCountryPresent(country?.toLowerCase())) {
        return false;
      }
    }
    return true;
  };

  // ***************** OCR FILE UPLOAD HANDLED *******************
  const onChangeFleet = (val, nextStep) => {
    setOwnerType(val);
  };

  const handleFileChange = (newFiles) => {
    setUploadedFileData((prev) => [...prev, ...newFiles]);
  };

  const handleFileDelete = (fileNameToDelete) => {
    setUploadedFileData((prev) =>
      prev.filter((fileItem) => fileItem?.file?.name !== fileNameToDelete)
    );
  };
  const handleOCRConfirmFileDelete = (fileNameToDelete) => {
    setOcrConfirmedFiles((prev) =>
      // prev.filter((_, index) => index !== indexToDelete)
      prev.filter((fileItem) => fileItem?.file?.name !== fileNameToDelete)
    );
    setUploadedFileData((prev) =>
      prev.filter((fileItem) => fileItem?.file?.name !== fileNameToDelete)
    );
  };

  const handleOCRConformFileChange = (newFiles) => {
    console.log("handleOCRConformFileChange", newFiles);
    setOcrConfirmedFiles((prev) => [...prev, ...newFiles]);
  };

  const onClickProceed = () => {
    if (uploadedFileData.length === 0) {
      Notification.warning("Warning", "Please upload at least one document.");
      return;
    }
    setOcrConfirmedFiles([...uploadedFileData]);
    // setIsUploadingPopupVisible(true);
  };

  const config = {
    onUploadProgress: function (progressEvent) {
      console.log("progressEvent.total", progressEvent.total);
      console.log("progressEvent.loaded", progressEvent.loaded);
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );

      setUploadState((prev) => {
        let status = "";
        let description = "";

        if (!prev.started) {
          status = "Hold Tight - File is Being Prepared Securely.";
          description = "Please don’t close or refresh the screen.";
        } else if (percentCompleted < 30) {
          status = "Hold Tight - File is Being Prepared Securely.";
          description = "Please don’t close or refresh the screen.";
        } else if (percentCompleted < 70) {
          status = "Almost There - Preparing Your Documents.";
          description = "Making sure everything is in right place.";
        } else if (percentCompleted < 100) {
          status = "Final Step - Converting Your Content.";
          description = "Hang on, we’re wrapping up things.";
        } else {
          status = "Final Step - Converting Your Content.";
          description = "Hang on, we’re wrapping up things.";
        }

        return {
          progress: percentCompleted,
          status,
          description,
          started: true,
        };
      });
    },
  };

  const uploadToOCR = async () => {
    if (!ocrConfirmedFiles || ocrConfirmedFiles.length === 0) return;

    const parserAppMap = {
      // truck: process.env.REACT_APP_OCR_ASSET,
      // fleet: process.env.REACT_APP_OCR_SHIPPER_SUPPLIER,
      // driver: process.env.REACT_APP_OCR_DRIVER_STO,
      truck: "RDLj2vIouDleRWu0",
      fleet: "mCFBiv6Hcl8U02Sp",
      // driver: "2p1fqkPj0wFL9T0E",
      driver: "testqkPj0wFL9T0E",
    };
    // const parserApp = parserAppMap["fleet"] || "";
    const parserKey = ownerType === "STO" ? "driver" : "fleet";
    const userType = ownerType === "STO" ? "Driver" : "FleetOwner";
    const parserApp = parserAppMap[parserKey] || "";
    console.log("parserApp", parserApp);
    const form = new FormData();
    // form.append("file", uploadedFileData.file);

    ocrConfirmedFiles.forEach((item) => {
      if (item?.file) {
        form.append("files", item.file);
      }
    });
    form.append("parserApp", parserApp);
    form.append("userType", userType);
    form.append("countryCode", String(formValues.countryCode || ""));
    form.append("entityType",EntityTypes.SUPPLIER);
    // form.append("model", "v1");
    // form.append("extra_accuracy", "false");
    try {
      console.log("Sending to OCR", form.getAll("files"), parserApp);
      const response = await ocrCustomFileUploadService(form, config);
      console.log("OCR Upload Response:", response);
      const parsedData = response?.data?.data?.parsedData;
      // const ocrLogId = response?.data?.data?.ocrLogId;
      const newOcrLogId  = response?.data?.data?.ocrLogId;
      if (parsedData && newOcrLogId) {
        console.log("uploadToOCR parsedData", parsedData);
        setOcrParsedData(parsedData);
        // setOcrLogId(ocrLogId);
        setOcrLogId(prev =>
          prev ? `${prev},${newOcrLogId}` : String(newOcrLogId)
        );
        return parsedData;
      } else {
        console.warn("No parsedData in OCR response");
        // setOcrLogId("");
      }
    } catch (error) {
      console.error("OCR Upload Failed:", error);
      const message =
        error?.response?.data?.message ||
        "OCR upload failed due to a server error.";
      Notification.error("Upload Failed", message);
    }
  };

  const isOcrDataValid = (ocrParsedData) => {
    console.log("isOcrDataValid before", ocrParsedData);
    console.log("isOcrDataValid before ocrParsedData", !ocrParsedData);
    console.log(
      "isOcrDataValid before !ocrParsedData?.documents",
      !ocrParsedData?.documents
    );

    if (!ocrParsedData || !ocrParsedData?.documents) {
      return false;
    }

    return ocrParsedData.documents.every((doc) => {
      console.log(
        "isOcrDataValid",
        doc.status,
        Array.isArray(doc.errors),
        doc.errors?.length === 0
      );

      return (
        doc.status === true &&
        Array.isArray(doc.errors) &&
        doc.errors?.length === 0
      );
    });
  };

  const onClickSubmit = async () => {
    if (ocrParsedData && !isOcrDataValid(ocrParsedData)) {
      setMissingDocModal(true);
      return;
    }

    setIsUploadingPopupVisible(true);
    const parsedData = await uploadToOCR();
    setIsUploadingPopupVisible(false);
    setUploadState(initialUploadState);

    // Check for OCR data Has No Errors
    if (isOcrDataValid(parsedData)) {
      // setCurrentStep(SignUpSteps.BASIC_INFO);
      setNextBtn(true);
      setIsOcrFileUpload(false);
    } else {
      console.warn(
        "Validation failed: Some documents have errors or status is false."
      );
    }
  };

  const handleDrawerFileSubmit = async () => {
    setIsUploadingPopupVisible(true);
    // await uploadToOCR();
    const parsedData = await uploadToOCR();
    setIsUploadingPopupVisible(false);
    setUploadState(initialUploadState);
    if (isOcrDataValid(parsedData)) {
      // setCurrentStep(SignUpSteps.BASIC_INFO);
      setIsOcrFileUpload(false);
      setNextBtn(true);
      setOpenDrawer(false);
    } else {
      console.warn(
        "Validation failed: Some documents have errors or status is false."
      );
    }
  };

  const handleViewSampleClick = (type) => {
    setSampleType(type);
    setSamplePreviewOpen(true);
  };

  const onSkipSectionChange = () => {
    if (!ocrParsedData) {
      if (ocrConfirmedFiles.length > 0) {
        // Notification.warning(
        //   "Files Not Submitted",
        //   "No files were uploaded. Proceeding to the next step."
        // );
        // setMissingDocModal(true);
        setIsDiscardModalVisible(true);
      } else {
        setNextBtn(true);
        setIsOcrFileUpload(false);
      }
    } else {
      // Parsed data exists — show modal for missing documents
      // setMissingDocModal(true);
      setIsDiscardModalVisible(true);
    }
  };

  const handleProceedDiscardOcrData = () => {
    setIsDiscardModalVisible(false);
    setMissingDocModal(false);
    setNextBtn(true);

    // Reset OCR-related states
    setUploadedFileData([]);
    setOcrConfirmedFiles([]);
    setOcrParsedData(null);
    setOcrLogId("");
    setUploadState(initialUploadState);
  };


   const uniqueDocNumberRule = (fieldName) => ({
  validator: (_, value) => {
    const val = value?.toString().trim();
    if (!val) return Promise.resolve();
     if (
      (removeUniquenessCheckForCountry(addSupplierForm?.getFieldValue("country")))  &&
      (fieldName === "drivingLicenseNumber" || fieldName === "nationalId")
    ) {
      return Promise.resolve();
    }
    const {vatNumber,tradeLicenseNumber, drivingLicenseNumber, passportNumber, nationalId, visa = [] } =
      addSupplierForm.getFieldsValue();

    const allValues = [vatNumber,tradeLicenseNumber,drivingLicenseNumber, passportNumber,nationalId,
      ...visa?.map((v) => v?.documentNumber),
    ].filter(Boolean);
    const duplicates = allValues.filter((v) => v?.toString().trim() === val);
    return duplicates.length > 1
      ? Promise.reject(new Error(`Field must be unique`))
      : Promise.resolve();
  },
});
  return (
    <div>
      <Modal
        className="add-supplier-modal-form"
        width={addExistingSupplierModal ? "60rem" : "33rem"}
        open={isOpen}
        centered
        maskClosable={false}
        onCancel={() => {
          onClose();
        }}
        title={
          <div>
            {/* {nextBtnTwo ? "Add KYC Details" : t("SUPPLIER_ADD_SUPPLIER_BTN")}{" "} */}
            {nextBtnTwo
              ? "Add KYC Details"
              : supplierTypeSelected === "new"
              ? t("SUPPLIER_ADD_SUPPLIER_BTN")
              : supplierTypeSelected === "existing"
              ? "Add Existing Supplier"
              : "Add Supplier"}

            <span className="title-span"></span>
          </div>
        }
        footer={false}
      >
        {!addExistingSupplierModal ? (
          <div style={{}} className="add-modal-form">
            <Divider />

            {supplierTypeSelected === "new" && (
              <Form
                layout="vertical"
                form={addSupplierForm}
                className="ant-form"
              >
                {/* // ******* FILE UPLOAD STEPS ************** */}
                {nextBtnTwo ? (
                  <div className="truck-form-scroll">
                    {checkIsFleetOwnerOrBroker(formValues?.supplierType) ? (
                      <>
                        {checkIsTurkeyKazak(formValues?.country) ? (
                          <>
                            <span className="star-color">
                              {t("SUPPLIER_VAT/REGISTRATION_CERTIFICATE")}
                              <span>*</span>
                            </span>
                            {formValues?.country === "Kazakhstan" ? (
                              <>
                                <Row>
                                  <Col>
                                    <Form.Item
                                      name="tradeLicenseUpload"
                                      className="floating-label-form-item"
                                      rules={[
                                        {
                                          required: true,
                                          message: t("VAT_DOC_UPLOAD_REQUIRED"),
                                        },
                                      ]}
                                    >
                                      <Fileupload
                                        filetype={DocTypes.TRADE_LICENSE_FRONT}
                                        defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                          addSupplierForm.getFieldValue(
                                            "tradeLicenseUpload"
                                          )?.fileThumbUrl
                                        )}
                                        defaultFile={
                                          addSupplierForm.getFieldValue(
                                            "tradeLicenseUpload"
                                          )?.fileUrl
                                        }
                                        fileName={
                                          addSupplierForm.getFieldValue(
                                            "tradeLicenseUpload"
                                          )?.fileName
                                        }
                                        entityId=""
                                        accessFile={false}
                                        onChange={(value) => {
                                          onFileUploadDocs(
                                            value,
                                            "tradeLicenseUpload"
                                          );
                                        }}
                                        //updateFormValue={(val)=>{ addSupplierForm.setFieldsValue({ vatUpload: val })}}
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>
                                <Form.Item
                                  name="tradeLicenseNumber"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("VAT_REGISTRATION_REQUIRED"),
                                    },
                                    {
                                      validator: validateNotEmpty(
                                        "VAT Registration No."
                                      ),
                                    },
                                  ]}
                                  className="floating-label-form-item"
                                >
                                  <Input
                                    value={formValues?.tradeLicenseNumber}
                                    style={{ width: "100%" }}
                                    maxLength={20}
                                    className="floating-input"
                                    placeholder={t(
                                      "VAT_REGISTRATION_NO_PLACEHOLDER"
                                    )}
                                    onChange={(e) =>
                                      handleFormChange(
                                        "tradeLicenseNumber",
                                        e.target.value
                                      )
                                    }
                                  />
                                  <label className="floating-label">
                                    {t("VAT_REGISRATION_NUMBER")}
                                    <span>*</span>
                                  </label>
                                </Form.Item>
                                <Form.Item
                                  name="tradeExpiry"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("EXPIRY_DATE_REQUIRED"),
                                    },
                                  ]}
                                  className="floating-label-form-item"
                                >
                                  <DatePicker
                                    className="floating-input"
                                    format={format}
                                    placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                                    disabledDate={disablePastDates}
                                    value={
                                      formValues?.tradeExpiry
                                        ? dayjs(formValues?.tradeExpiry, format)
                                        : null
                                    }
                                    onChange={(date, dateString) =>
                                      handleFormChange(
                                        "tradeExpiry",
                                        dateString
                                      )
                                    }
                                  />
                                  <label className="floating-label">
                                    {" "}
                                    {t("EXPIRY_DATE")} <span>*</span>
                                  </label>
                                </Form.Item>
                              </>
                            ) : (
                              <>
                                <Row>
                                  <Col>
                                    <Form.Item
                                      name="vatUpload"
                                      className="floating-label-form-item"
                                      rules={[
                                        {
                                          required: true,
                                          message: t("VAT_DOC_UPLOAD_REQUIRED"),
                                        },
                                      ]}
                                    >
                                      <Fileupload
                                        filetype={DocTypes.VAT_FRONT}
                                        defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                          addSupplierForm.getFieldValue(
                                            "vatUpload"
                                          )?.fileThumbUrl
                                        )}
                                        defaultFile={
                                          addSupplierForm.getFieldValue(
                                            "vatUpload"
                                          )?.fileUrl
                                        }
                                        fileName={
                                          addSupplierForm.getFieldValue(
                                            "vatUpload"
                                          )?.fileName
                                        }
                                        entityId=""
                                        accessFile={false}
                                        onChange={(value) => {
                                          onFileUploadDocs(value, "vatUpload");
                                        }}
                                        //updateFormValue={(val)=>{ addSupplierForm.setFieldsValue({ vatUpload: val })}}
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>
                                <Form.Item
                                  name="vatNumber"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("VAT_REGISTRATION_REQUIRED"),
                                    },
                                    {
                                      validator: validateNotEmpty(
                                        "VAT Registration No."
                                      ),
                                    },
                                  ]}
                                  className="floating-label-form-item"
                                >
                                  <Input
                                    value={formValues?.vatNumber}
                                    style={{ width: "100%" }}
                                    maxLength={20}
                                    className="floating-input"
                                    placeholder={t(
                                      "VAT_REGISTRATION_NO_PLACEHOLDER"
                                    )}
                                    onChange={(e) =>
                                      handleFormChange(
                                        "vatNumber",
                                        e.target.value
                                      )
                                    }
                                  />
                                  <label className="floating-label">
                                    {t("VAT_REGISRATION_NUMBER")}
                                    <span>*</span>
                                  </label>
                                </Form.Item>
                                <Form.Item
                                  name="vatExpiry"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("EXPIRY_DATE_REQUIRED"),
                                    },
                                  ]}
                                  className="floating-label-form-item"
                                >
                                  <DatePicker
                                    className="floating-input"
                                    format={format}
                                    placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                                    disabledDate={disablePastDates}
                                    value={
                                      formValues?.vatExpiry
                                        ? dayjs(formValues?.vatExpiry, format)
                                        : null
                                    }
                                    onChange={(date, dateString) =>
                                      handleFormChange("vatExpiry", dateString)
                                    }
                                  />
                                  <label className="floating-label">
                                    {t("SIGNUP_KYC_TRADE_LIC_EXPIRY")}{" "}
                                    <span>*</span>
                                  </label>
                                </Form.Item>
                              </>
                            )}
                            <Form.Item
                              name="registrationOffice"
                              rules={[
                                {
                                  required: true,
                                  message: t("REGISTRATION_OFFICE_REQUIRED"),
                                },
                              ]}
                              className="floating-label-form-item"
                            >
                              <Input
                                placeholder="Enter Registration Office"
                                className="floating-input"
                                onChange={(e) =>
                                  addSupplierForm.setFieldValue(
                                    "registrationOffice",
                                    e.target.value
                                  )
                                }
                              />
                              <label className="floating-label">
                                {t("ACCOUNT_REG_OFFICE")}
                                <b className="mandate-color">*</b>
                              </label>
                            </Form.Item>
                            <label className="registration-lable">
                              {t("REGISTRATION_DISTRICT_OFFICE_TAX_LABEL")}
                            </label>
                            <Row style={{ margin: "5px 0 0 0" }}>
                              <Col className="col-name">
                                {t("FILE_VERIFY_IBAN_CERTIFICATE_NUMBER")}
                              </Col>
                            </Row>

                            <Row>
                              <Col span={11}>
                                {ibanNumber?.map((ele, index) => (
                                  <>
                                    <Form.Item
                                      name={`vatRegistration_${index}`}
                                      rules={[
                                        {
                                          required: true,
                                          message: t("IBAN_REQUIRED"),
                                        },
                                        // {
                                        //     pattern: new RegExp("^[a-zA-Z0-9\-]+$"),
                                        //     message:"Please enter the correct format!",
                                        //   }
                                      ]}
                                      className="floating-label-form-item"
                                    >
                                      <Input
                                        placeholder={t("IBAN_PLACEHOLDER")}
                                        className="floating-input"
                                        maxLength={
                                          formValues?.country === "Kazakhstan"
                                            ? 20
                                            : formValues?.country === "Turkey"
                                            ? 26
                                            : 34
                                        }
                                        onChange={(e) => {
                                          handleIbanNumberChange(
                                            e.target.value,
                                            index
                                          );
                                        }}
                                      />
                                      <label className="floating-label">
                                        {t("IBAN_NUMBER_KEY")}
                                        <b className="mandate-color">*</b>
                                      </label>
                                    </Form.Item>
                                  </>
                                ))}

                                <Row gutter={16}>
                                  <Col span={16}>
                                    <label className="registration-lable">
                                      {t("MUST_BE_KEY")}{" "}
                                      {formValues?.country === "Kazakhstan"
                                        ? "20"
                                        : formValues?.country === "Turkey"
                                        ? "26"
                                        : "34"}{" "}
                                      {t("ACCOUNT_DIGITS")}
                                    </label>
                                  </Col>
                                  <Col span={8}>
                                    <Button
                                      type="secondary"
                                      icon={<PlusOutlined />}
                                      className="add-doc"
                                      onClick={addIbanNumber}
                                    >
                                      {t("ACCOUNT_ADD_IBAN")}
                                    </Button>
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={12} className="col-item">
                                <Form.Item
                                  rules={[
                                    {
                                      required: true,
                                      message: 't("CERTIFICATION_REQUIRED")',
                                    },
                                  ]}
                                  name="certification"
                                  className="floating-label-form-item"
                                >
                                  <Select
                                    className="floating-selectt"
                                    options={[
                                      { label: "K1", value: "K1" },
                                      { label: "C2", value: "C2" },
                                    ]}
                                    onChange={(value) => {
                                      addSupplierForm.setFieldsValue({
                                        certification: value,
                                      });
                                    }}
                                    style={{ width: "100%", height: "56px" }}
                                  />
                                  <label className="floating-label">
                                    {t("FILE_VERIFY_CERTIFICATE")}
                                    <b className="mandate-color">*</b>
                                  </label>
                                </Form.Item>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <>
                            <span className="star-color">
                              {t("SIGNUP_KYC_VAT_REG_HEADER")}
                              <span>*</span>
                            </span>
                            <Row>
                              <Col>
                                <Form.Item
                                  name="vatUpload"
                                  className="floating-label-form-item"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("VAT_DOC_UPLOAD_REQUIRED"),
                                    },
                                  ]}
                                >
                                  <Fileupload
                                    filetype={DocTypes.VAT_FRONT}
                                    defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                      addSupplierForm.getFieldValue("vatUpload")
                                        ?.fileThumbUrl
                                    )}
                                    defaultFile={
                                      addSupplierForm.getFieldValue("vatUpload")
                                        ?.fileUrl
                                    }
                                    fileName={
                                      addSupplierForm.getFieldValue("vatUpload")
                                        ?.fileName
                                    }
                                    entityId=""
                                    entityType={EntityTypes.SUPPLIER}
                                    accessFile={false}
                                    onChange={(value) => {
                                      onFileUploadDocs(value, "vatUpload");
                                    }}
                                    //updateFormValue={(val)=>{ addSupplierForm.setFieldsValue({ vatUpload: val })}}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Form.Item
                              name="vatNumber"
                              rules={[
                                {
                                  required: true,
                                  message: t("VAT_REGISTRATION_REQUIRED"),
                                },
                                uniqueDocNumberRule("vatNumber"),
                                {
                                  validator: validateNotEmpty(
                                    "VAT Registration No."
                                  ),
                                },
                              ]}
                              className="floating-label-form-item"
                            >
                              <Input
                                value={formValues?.vatNumber}
                                style={{ width: "100%" }}
                                maxLength={20}
                                className="floating-input"
                                placeholder={t(
                                  "VAT_REGISTRATION_NO_PLACEHOLDER"
                                )}
                                onChange={(e) =>
                                  handleFormChange("vatNumber", e.target.value)
                                }
                              />
                              <label className="floating-label">
                                {t("VAT_REGISTRATION_NO_LABEL")} <span>*</span>
                              </label>
                            </Form.Item>
                            <Form.Item
                              name="vatExpiry"
                              rules={[
                                {
                                  required: true,
                                  message: t("EXPIRY_DATE_REQUIRED"),
                                },
                              ]}
                              className="floating-label-form-item"
                            >
                              <DatePicker
                                className="floating-input"
                                format={format}
                                placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                                disabledDate={disablePastDates}
                                value={
                                  formValues?.vatExpiry
                                    ? dayjs(formValues?.vatExpiry, format)
                                    : null
                                }
                                onChange={(date, dateString) =>
                                  handleFormChange("vatExpiry", dateString)
                                }
                              />
                              <label className="floating-label">
                                {" "}
                                {t("EXPIRY_DATE")} <span>*</span>
                              </label>
                            </Form.Item>
                            <span className="star-color">
                              {t("TRADE_LICENSE_LABEL")}
                              <span>*</span>
                            </span>
                            <Row>
                              <Col>
                                <Form.Item
                                  name="tradeLicenseUpload"
                                  className="floating-label-form-item"
                                  rules={[
                                    {
                                      required: true,
                                      message: t(
                                        "UPLOAD_TRADE_LICENCE_DOC_REQUIRED"
                                      ),
                                    },
                                  ]}
                                >
                                  <Fileupload
                                    filetype={DocTypes.TRADE_LICENSE_FRONT}
                                    defaultThumbFile={documentUtility?.getThumbnailImagePath(
                                      addSupplierForm.getFieldValue(
                                        "tradeLicenseUpload"
                                      )?.fileThumbUrl
                                    )}
                                    defaultFile={
                                      addSupplierForm.getFieldValue(
                                        "tradeLicenseUpload"
                                      )?.fileUrl
                                    }
                                    fileName={
                                      addSupplierForm.getFieldValue(
                                        "tradeLicenseUpload"
                                      )?.fileName
                                    }
                                    entityId=""
                                    entityType={EntityTypes.SUPPLIER}
                                    accessFile={false}
                                    onChange={(value) => {
                                      onFileUploadDocs(
                                        value,
                                        "tradeLicenseUpload"
                                      );
                                    }}
                                    //updateFormValue={(val)=>{ addSupplierForm.setFieldsValue({ vatUpload: val })}}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Form.Item
                              name="tradeLicenseNumber"
                              rules={[
                                {
                                  required: true,
                                  message: t("TRADE_LICENCE_DOC_REQUIRED"),
                                },
                                {
                                  validator: validateNotEmpty(
                                    "VAT Registration No."
                                  ),
                                },
                                uniqueDocNumberRule("tradeLicenseNumber")
                              ]}
                              className="floating-label-form-item"
                            >
                              <Input
                                value={formValues?.tradeLicenseNumber}
                                style={{ width: "100%" }}
                                maxLength={20}
                                className="floating-input"
                                placeholder={t("SIGNUP_KYC_TRADE_LIC_NUM_PH")}
                                onChange={(e) =>
                                  handleFormChange(
                                    "tradeLicenseNumber",
                                    e.target.value
                                  )
                                }
                              />
                              <label className="floating-label">
                                {t("ACCOUNT_KYC_DETAILS_TRADE_LICENSE_NO")}{" "}
                                <span>*</span>
                              </label>
                            </Form.Item>
                            <Form.Item
                              name="tradeExpiry"
                              rules={[
                                {
                                  required: true,
                                  message: t("EXPIRY_DATE_REQUIRED"),
                                },
                              ]}
                              className="floating-label-form-item"
                            >
                              <DatePicker
                                className="floating-input"
                                format={format}
                                placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                                disabledDate={disablePastDates}
                                value={
                                  formValues?.tradeExpiry
                                    ? dayjs(formValues?.tradeExpiry, format)
                                    : null
                                }
                                onChange={(date, dateString) =>
                                  handleFormChange("tradeExpiry", dateString)
                                }
                              />
                              <label className="floating-label">
                                {" "}
                                {t("EXPIRY_DATE")} <span>*</span>
                              </label>
                            </Form.Item>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <span className="star-color">
                          {t("FLEET_DRIVER_DRIVING_LICENSE")} <span>*</span>
                        </span>
                        <Row gutter={16}>
                          <Col span={12}>
                            <Form.Item
                              name="licenceFront"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("UPLOAD_LICENCE_FRONT_REQUIRED"),
                                },
                              ]}
                            >
                              <Fileupload
                                filetype={DocTypes.DL_FRONT}
                                defaultThumbFile={documentUtility.getThumbnailImagePath(
                                  addSupplierForm.getFieldValue("licenceFront")
                                    ?.fileThumbUrl
                                )}
                                defaultFile={
                                  addSupplierForm.getFieldValue("licenceFront")
                                    ?.fileUrl
                                }
                                fileName={
                                  addSupplierForm.getFieldValue("licenceFront")
                                    ?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={true}
                                name={t("KYC_UPLOAD_FRONT_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "licenceFront");
                                }}
                                updateFormValue={(val) => {
                                  addSupplierForm.setFieldsValue({
                                    licenceFront: val,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              name="licenceBack"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t("UPLOAD_LICENCE_BACK_REQUIRED"),
                                },
                              ]}
                            >
                              <Fileupload
                                filetype={DocTypes.DL_BACK}
                                defaultThumbFile={documentUtility.getThumbnailImagePath(
                                  addSupplierForm.getFieldValue("licenceBack")
                                    ?.fileThumbUrl
                                )}
                                defaultFile={
                                  addSupplierForm.getFieldValue("licenceBack")
                                    ?.fileUrl
                                }
                                fileName={
                                  addSupplierForm.getFieldValue("licenceBack")
                                    ?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={true}
                                name={t("KYC_UPLOAD_BACK_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "licenceBack");
                                }}
                                updateFormValue={(val) => {
                                  addSupplierForm.setFieldsValue({
                                    licenceBack: val,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Form.Item
                          name="drivingLicenseNumber"
                          rules={[
                            {
                              required: true,
                              message: t("DRIVING_LICENCE_NO_REQUIRED"),
                            },
                            uniqueDocNumberRule("drivingLicenseNumber"),

                            {
                              validator: validateNotEmpty(
                                "driving license number"
                              ),
                            },
                          ]}
                          className="floating-label-form-item"
                        >
                          <Input
                            value={addSupplierForm.getFieldValue(
                              "drivingLicenseNumber"
                            )}
                            maxLength={20}
                            style={{ width: "100%" }}
                            className="floating-input"
                            placeholder={t("DRIVING_LICENSE_PLACEHOLDER")}
                            onChange={(e) =>
                              handleFormChange(
                                "drivingLicenseNumber",
                                e.target.value
                              )
                            }
                          />
                          <label className="floating-label">
                            {t("FLEET_DRIVER_DRIVING_LICENSE_NO")}{" "}
                            <span>*</span>
                          </label>
                        </Form.Item>
                        <Form.Item
                          name="licenseExpiry"
                          rules={[
                            {
                              required: true,
                              message: t("EXPIRY_DATE_REQUIRED"),
                            },
                          ]}
                          className="floating-label-form-item"
                        >
                          <DatePicker
                            className="floating-input"
                            format={format}
                            placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                            disabledDate={disablePastDates}
                            value={
                              addSupplierForm.getFieldValue("licenseExpiry")
                                ? dayjs(
                                    addSupplierForm.getFieldValue(
                                      "licenseExpiry"
                                    ),
                                    format
                                  )
                                : null
                            }
                            onChange={(date, dateString) =>
                              handleFormChange("licenseExpiry", dateString)
                            }
                          />
                          <label className="floating-label">
                            {t("FLEET_DRIVER_EXPIRY_DATE")} <span>*</span>
                          </label>
                        </Form.Item>
                        <span className="star-color">
                          {t("FLEET_DRIVER_NATIONAL_ID")} <span>*</span>
                        </span>
                        <Row gutter={16}>
                          <Col span={12}>
                            <Form.Item
                              name="nationalIdFront"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t(
                                    "NATIONAL_ID_FRONT_UPLOAD_REQUIRED"
                                  ),
                                },
                              ]}
                            >
                              <Fileupload
                                filetype={DocTypes.NATIONAL_ID_FRONT}
                                defaultThumbFile={documentUtility.getThumbnailImagePath(
                                  addSupplierForm.getFieldValue(
                                    "nationalIdFront"
                                  )?.fileThumbUrl
                                )}
                                defaultFile={
                                  addSupplierForm.getFieldValue(
                                    "nationalIdFront"
                                  )?.fileUrl
                                }
                                fileName={
                                  addSupplierForm.getFieldValue(
                                    "nationalIdFront"
                                  )?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={true}
                                name={t("KYC_UPLOAD_FRONT_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "nationalIdFront");
                                }}
                                updateFormValue={(val) => {
                                  addSupplierForm.setFieldsValue({
                                    nationalIdFront: val,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              name="nationalIdBack"
                              className="floating-label-form-item"
                              rules={[
                                {
                                  required: true,
                                  message: t(
                                    "NATIONAL_ID_BACK_UPLOAD_REQUIRED"
                                  ),
                                },
                              ]}
                            >
                              <Fileupload
                                filetype={DocTypes.NATIONAL_ID_BACK}
                                defaultThumbFile={documentUtility.getThumbnailImagePath(
                                  addSupplierForm.getFieldValue(
                                    "nationalIdBack"
                                  )?.fileThumbUrl
                                )}
                                defaultFile={
                                  addSupplierForm.getFieldValue(
                                    "nationalIdBack"
                                  )?.fileUrl
                                }
                                fileName={
                                  addSupplierForm.getFieldValue(
                                    "nationalIdBack"
                                  )?.fileName
                                }
                                entityId=""
                                entityType={EntityTypes.SUPPLIER}
                                accessFile={true}
                                name={t("KYC_UPLOAD_BACK_LBL")}
                                onChange={(value) => {
                                  onFileUploadDocs(value, "nationalIdBack");
                                }}
                                updateFormValue={(val) => {
                                  addSupplierForm.setFieldsValue({
                                    nationalIdBack: val,
                                  });
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Form.Item
                          name="nationalId"
                          rules={[
                            {
                              required: true,
                              message: t("NATIONAL_ID_REQUIRED"),
                            },
                            { validator: validateNotEmpty("national Id") },
                             uniqueDocNumberRule("nationalId")

                          ]}
                          className="floating-label-form-item"
                        >
                          <Input
                            value={addSupplierForm.getFieldValue("nationalId")}
                            maxLength={20}
                            style={{ width: "100%" }}
                            className="floating-input"
                            placeholder={t("NATIONAL_ID_PLACEHOLDER")}
                            onChange={(e) =>
                              handleFormChange("nationalId", e.target.value)
                            }
                          />
                          <label className="floating-label">
                            {t("FLEET_DRIVER_NATIONAL_ID")} <span>*</span>
                          </label>
                        </Form.Item>
                        <Form.Item
                          name="nationalIdExpiry"
                          rules={[
                            {
                              required: true,
                              message: t("EXPIRY_DATE_REQUIRED"),
                            },
                          ]}
                          className="floating-label-form-item"
                        >
                          <DatePicker
                            className="floating-input"
                            format={format}
                            placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                            disabledDate={disablePastDates}
                            value={
                              addSupplierForm.getFieldValue("nationalIdExpiry")
                                ? dayjs(
                                    addSupplierForm.getFieldValue(
                                      "nationalIdExpiry"
                                    ),
                                    format
                                  )
                                : null
                            }
                            onChange={(date, dateString) =>
                              handleFormChange("nationalIdExpiry", dateString)
                            }
                          />
                          <label className="floating-label">
                            {t("FLEET_DRIVER_EXPIRY_DATE")} <span>*</span>
                          </label>
                        </Form.Item>
                        {formValues?.serviceType?.length > 0 &&
                        formValues?.serviceType?.includes("Domestic") &&
                        formValues?.serviceType?.length === 1 ? (
                          <></>
                        ) : (
                          <>
                            <span className="star-color">
                              {t("FLEET_DRIVER_PASSPORT")} <span>*</span>
                            </span>
                            <Row gutter={16}>
                              <Col span={12}>
                                <Form.Item
                                  name="passportFront"
                                  className="floating-label-form-item"
                                  rules={[
                                    {
                                      required: true,
                                      message: t(
                                        "PASSPORT_FRONT_UPLOAD_REQUIRED"
                                      ),
                                    },
                                  ]}
                                >
                                  <Fileupload
                                    filetype={DocTypes.PASSPORT_FRONT}
                                    defaultThumbFile={documentUtility.getThumbnailImagePath(
                                      addSupplierForm.getFieldValue(
                                        "passportFront"
                                      )?.fileThumbUrl
                                    )}
                                    defaultFile={
                                      addSupplierForm.getFieldValue(
                                        "passportFront"
                                      )?.fileUrl
                                    }
                                    fileName={
                                      addSupplierForm.getFieldValue(
                                        "passportFront"
                                      )?.fileName
                                    }
                                    entityId=""
                                    entityType={EntityTypes.SUPPLIER}
                                    accessFile={true}
                                    name={t("KYC_UPLOAD_FRONT_LBL")}
                                    onChange={(value) => {
                                      onFileUploadDocs(value, "passportFront");
                                    }}
                                    updateFormValue={(val) => {
                                      addSupplierForm.setFieldsValue({
                                        passportFront: val,
                                      });
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  className="floating-label-form-item"
                                  name="passportBack"
                                  rules={[
                                    {
                                      required: true,
                                      message: t(
                                        "PASSPORT_BACK_UPLOAD_REQUIRED"
                                      ),
                                    },
                                  ]}
                                >
                                  <Fileupload
                                    filetype={DocTypes.PASSPORT_BACK}
                                    defaultThumbFile={documentUtility.getThumbnailImagePath(
                                      addSupplierForm.getFieldValue(
                                        "passportBack"
                                      )?.fileThumbUrl
                                    )}
                                    defaultFile={
                                      addSupplierForm.getFieldValue(
                                        "passportBack"
                                      )?.fileUrl
                                    }
                                    fileName={
                                      addSupplierForm.getFieldValue(
                                        "passportBack"
                                      )?.fileName
                                    }
                                    entityId=""
                                    entityType={EntityTypes.SUPPLIER}
                                    accessFile={true}
                                    name={t("KYC_UPLOAD_BACK_LBL")}
                                    onChange={(value) => {
                                      onFileUploadDocs(value, "passportBack");
                                    }}
                                    updateFormValue={(val) => {
                                      addSupplierForm.setFieldsValue({
                                        passportBack: val,
                                      });
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Form.Item
                              name="passportNumber"
                              rules={[
                                {
                                  required: true,
                                  message: t("PASSPORT_NO_REQUIRED"),
                                },
                                {
                                  validator:
                                    validateNotEmpty("passport number"),
                                },
                                uniqueDocNumberRule(["passportNumber"])
                              ]}
                              className="floating-label-form-item"
                            >
                              <Input
                                value={addSupplierForm.getFieldValue(
                                  "passportNumber"
                                )}
                                maxLength={20}
                                style={{ width: "100%" }}
                                className="floating-input"
                                placeholder="Enter Passport Number"
                                onChange={(e) =>
                                  handleFormChange(
                                    "passportNumber",
                                    e.target.value
                                  )
                                }
                              />
                              <label className="floating-label">
                                {t("FLEET_DRIVER_PASSPORT_NO")}
                                <span>*</span>
                              </label>
                            </Form.Item>
                            <Form.Item
                              name="passportExpiry"
                              rules={[
                                {
                                  required: true,
                                  message: t("EXPIRY_DATE_REQUIRED"),
                                },
                              ]}
                              className="floating-label-form-item"
                            >
                              <DatePicker
                                className="floating-input"
                                format={format}
                                placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                                disabledDate={disablePastDates}
                                value={
                                  addSupplierForm.getFieldValue(
                                    "passportExpiry"
                                  )
                                    ? dayjs(
                                        addSupplierForm.getFieldValue(
                                          "passportExpiry"
                                        ),
                                        format
                                      )
                                    : null
                                }
                                onChange={(date, dateString) =>
                                  handleFormChange("passportExpiry", dateString)
                                }
                              />
                              <label className="floating-label">
                                {t("FLEET_DRIVER_EXPIRY_DATE")} <span>*</span>
                              </label>
                            </Form.Item>
                            <span className="star-color">
                              {t("FLEET_DRIVER_VISA")} <span></span>
                            </span>
                            {visa?.map((data, index) => (
                              <div key={index}>
                                {visa?.length > 1 && index !== 0 && (
                                  <Row
                                    justify={"end"}
                                    className="delete-visa"
                                    onClick={() => {
                                      const updatedVisa = [...visa];
                                      updatedVisa.splice(index, 1);
                                      setVisa(updatedVisa);
                                    }}
                                  >
                                    {t("ACCOUNT_REMOVE")}
                                  </Row>
                                )}
                                <Form.Item
                                  className="floating-label-form-item"
                                  name={["visa", index, "frontDoc"]}
                                  // rules={[
                                  //     { required: true, message: t("PASSPORT_BACK_UPLOAD_REQUIRED") },
                                  // ]}
                                >
                                  <Fileupload
                                    filetype={DocTypes.VISA_FRONT}
                                    defaultThumbFile={
                                      data?.frontDoc?.documentPathThumb
                                    }
                                    defaultFile={data?.frontDoc?.documentPath}
                                    fileName={data?.frontDoc?.fileName}
                                    entityId={""}
                                    entityType={EntityTypes.SUPPLIER}
                                    accessFile={false}
                                    onChange={(value) => {
                                      handleVisaDocumentChange(value, index);
                                    }}
                                  />
                                </Form.Item>

                                <Form.Item
                                  className="floating-label-form-item"
                                  name={["visa", index, "documentNumber"]}
                                  rules={[
                                    {
                                      validator:
                                        validateNotEmpty("visa number"),
                                    },
                                    uniqueDocNumberRule(["visa",index,"documentNumber"])
                                  ]}
                                >
                                  <Input
                                    value={data?.documentNumber || ""}
                                    style={{ width: "100%" }}
                                    maxLength={25}
                                    className="floating-input"
                                    placeholder={t("VISA_PLACEHOLDER")}
                                    onChange={(e) => {
                                      handleVisa(
                                        { documentNumber: e.target.value },
                                        index
                                      );
                                    }}
                                  />
                                  <label className="floating-label">
                                    {t("FLEET_DRIVER_VISA_NO")} <span></span>
                                  </label>
                                </Form.Item>
                                <Form.Item
                                  className="floating-label-form-item"
                                  //   name={"visa_" + index + "_issuingCountry"}
                                  name={["visa", index, "issuingCountry"]}
                                  // rules={[
                                  //     {
                                  //         required: true,
                                  //         message: t("ISSUE_COUNTRY_VALIDATION"),
                                  //     },
                                  // ]}
                                >
                                  <Select
                                    name="issuingCountry"
                                    className="floating-selectt"
                                    options={countryOptions}
                                    showSearch
                                    placeholder={t(
                                      "ISSUING_COUNTRY_PLACEHOLDER"
                                    )}
                                    value={data?.issuingCountry}
                                    fieldNames={{
                                      label: "name",
                                      value: "name",
                                    }}
                                    onChange={(value) => {
                                      //   addDriverForm.setFieldsValue({
                                      //     ["visa_" + index + "_issuingCountry"]: value,
                                      //   });
                                      //   handleFormChange("visa_" + index + "_issuingCountry", value);
                                      handleVisa(
                                        { issuingCountry: value },
                                        index
                                      );
                                    }}
                                    loading={issuingCountriesListWaiter}
                                    filterOption={(input, option) =>
                                      option.name
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                  />
                                  <label className="floating-label">
                                    {t("ACCOUNT_ISSUNING_COUNTRY")}{" "}
                                    <span></span>
                                  </label>
                                </Form.Item>
                                <Form.Item
                                  className="floating-label-form-item"
                                  name={["visa", index, "expiryDate"]}
                                  // rules={[
                                  //     {
                                  //         required: true,
                                  //         message: t("EXPIRY_DATE_REQUIRED"),
                                  //     },
                                  // ]}
                                >
                                  <DatePicker
                                    className="floating-input"
                                    format={format}
                                    placeholder={t("EXPIRY_DATE_PLACEHOLDER")}
                                    disabledDate={disablePastDates}
                                    value={
                                      data?.expiryDate
                                        ? dayjs(
                                            data.expiryDate,
                                            "YYYY-MM-DD"
                                          ).isValid()
                                          ? dayjs(data.expiryDate, "YYYY-MM-DD")
                                          : dayjs(data.expiryDate, "DD/MM/YYYY")
                                        : null
                                    }
                                    onChange={(date, dateString) => {
                                      handleVisa(
                                        { expiryDate: dateString },
                                        index
                                      );
                                    }}
                                  />
                                  <label className="floating-label">
                                    {t("FLEET_DRIVER_EXPIRY_DATE")}{" "}
                                    <span></span>
                                  </label>
                                </Form.Item>
                              </div>
                            ))}
                            <Button
                              type="secondary"
                              icon={<PlusOutlined />}
                              className="add-doc"
                              onClick={addVisa}
                              disabled={visa?.length >= 5}
                            >
                              {/* {t("KYC_INFO_ADD_VISA")} */}
                              {t("ACCOUNT_ADD_DOC")}
                            </Button>
                          </>
                        )}
                      </>
                    )}
                  </div>
                ) : //  ****** OCR FILE UPLOADS STEPS *********
                // {isOcrFileUpload && }
                isOcrFileUpload ? (
                  <>
                    {!ownerType ? (
                      <div className="radio-div">
                        <Radio.Group
                          size="small"
                          onChange={(e) => {
                            onChangeFleet(e.target.value);
                            handleFormChange("supplierType", e.target.value);
                          }}
                          value={ownerType}
                          style={{
                            width: "100%",
                          }}
                        >
                          <Space direction="vertical" className="space-radio">
                            <Radio.Button
                              value={OwnerType.FLEET_OWNER}
                              className={
                                ownerType == OwnerType.FLEET_OWNER
                                  ? "radio-list-active"
                                  : "radio-list"
                              }
                              style={{ borderRadius: "24px" }}
                              // onClick={() => {
                              // setRadioClick(OwnerType.FLEET_OWNER);
                              // }}
                            >
                              <div className="radio-row">
                                <div>
                                  <img
                                    src={FleetOwner}
                                    className="image-size"
                                  />
                                </div>
                                <div className="radio-content-div">
                                  <Text
                                    className="radio-content"
                                    style={{ fontSize: "18px" }}
                                    ellipsis={{ tooltip: true }}
                                  >
                                    {t("SIGNUP_FLEET_OWNER_HEADER")}
                                  </Text>
                                  <Text
                                    className="radio-content-2"
                                    style={{ width: "15rem" }}
                                    ellipsis={{ tooltip: true }}
                                  >
                                    {t("SIGNUP_FLEET_OWNER_SUB_HEADER")}
                                  </Text>
                                </div>
                              </div>
                            </Radio.Button>

                            <Radio.Button
                              // value={OwnerType.INDIVIDUAL_OWNER}
                              value={OwnerType.STO}
                              className={
                                ownerType == "IndividualOwner"
                                  ? "radio-list-active"
                                  : "radio-list"
                              }
                              style={{ borderRadius: "24px" }}
                              // onClick={() => {
                              // setRadioClick(OwnerType.INDIVIDUAL_OWNER);
                              // }}
                            >
                              <div className="radio-row">
                                <div>
                                  <img
                                    src={IndividualOwner}
                                    className="image-size"
                                  />
                                </div>
                                <div className="radio-content-div">
                                  <Text
                                    className="radio-content"
                                    style={{ fontSize: "18px" }}
                                    ellipsis={{ tooltip: true }}
                                  >
                                    {t("SIGNUP_FLEET_INDIVIDUAL_HEADER")}
                                  </Text>
                                  <Text
                                    className="radio-content-2"
                                    style={{ width: "15rem" }}
                                    ellipsis={{ tooltip: true }}
                                  >
                                    {t("SIGN_UP_MSG")}
                                  </Text>
                                </div>
                              </div>
                            </Radio.Button>
                          </Space>
                        </Radio.Group>
                      </div>
                    ) : (
                      <div className="ocr-file-upload-block">
                        {ocrConfirmedFiles.length === 0 ? (
                          <AutofillDocUpload
                            onFileUpload={handleFileChange}
                            filetype={frontDocs}
                            multipleUploadedFilesData={uploadedFileData}
                            onFileDelete={handleFileDelete}
                            onViewSample={handleViewSampleClick}
                            ownerType={ownerType}
                          />
                        ) : (
                          <DocumentListView
                            documentData={ocrConfirmedFiles}
                            onDelete={handleOCRConfirmFileDelete}
                            openUploadDrawer={() => setOpenDrawer(true)}
                            ocrParsedDataDocuments={
                              ocrParsedData?.documents || []
                            }
                          />
                        )}
                      </div>
                    )}
                  </>
                ) : // ******* BASIC INFO STEP **************
                nextBtn ? (
                  <div className="truck-form-items">
                    <Row className="truck-form-items-mobile">
                      <Col span={5} style={{ paddingRight: "8px" }}>
                        <Form.Item
                          name="countryCode"
                          className="floating-label-form-item"
                        >
                          <Select
                            type="number"
                            showSearch
                            className="floating-selectt country-code-select"
                            popupClassName="country-code-popup"
                            placeholder={t("COUNTRY_CODE_LBL")}
                            fieldNames={{
                              label: "label",
                              value: "phone_code",
                            }}
                            disabled={verifyMobile}
                            value={addSupplierForm?.getFieldValue(
                              "countryCode"
                            )}
                            loading={mobileCountryCodeLoader}
                            options={mobileCountryCodeList.map((item) => ({
                              ...item,
                              key: `${item.phone_code}-${
                                item.country_code
                              }-${item.name.replace(/\s+/g, "")}`, // Unique key
                            }))}
                            onChange={(e, option) =>
                              handleFormChange("countryCode", e, option)
                            }
                            onSearch={(value) => {
                              if (!/^\d*$/.test(value)) {
                                return;
                              }
                            }}
                            filterOption={(input, option) =>
                              option?.searchKey?.includes(input.toLowerCase())
                            }
                          />
                          <label className="floating-label">
                            {t("COUNTRY_CODE_LBL")} <span>*</span>
                          </label>
                        </Form.Item>
                      </Col>
                      <Col span={19}>
                        <Form.Item
                          name="mobileNumber"
                          className="floating-label-form-item"
                          rules={[
                            {
                              required: true,
                              message: t("MOBILE_NO_REQUIRED"),
                            },
                            {
                              pattern: /^[0-9]*$/,
                              message: t("MOBILE_NO_VALIDATION_REQUIRED"),
                            },
                            {
                              validator: (rule, value) =>
                                validateMobileNumber(
                                  addSupplierForm?.getFieldValue("countryCode"),
                                  value,
                                  t
                                ),
                            },
                          ]}
                        >
                          <Input
                            style={{ width: "100%" }}
                            name="mobileNumber"
                            className="floating-input"
                            disabled={verifyMobile}
                            placeholder={t("ENTER_MOBILE_NO_COMMON")}
                            onChange={(e) =>
                              handleFormChange("mobile", e.target.value)
                            }
                            value={addSupplierForm?.getFieldValue(
                              "mobileNumber"
                            )}
                            minLength={minMaxMobileNoLength.minLength}
                            maxLength={minMaxMobileNoLength.maxLength}
                          />
                          <label className="floating-label">
                            {t("ACCOUNT_BASIC_DETAILS_MOBILE_NO")}
                            <span>*</span>
                          </label>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item
                      name="supplierName"
                      rules={[
                        {
                          required: true,
                          message: t("SUPPLIER_NAME_REQUIRED"),
                        },
                        // { validator: validateNotEmpty("supplier name") },
                      ]}
                      className="floating-label-form-item"
                    >
                      <Input
                        style={{ width: "100%" }}
                        value={formValues?.supplierName}
                        className="floating-input"
                        placeholder={t("SUPPLIER_NAME_PLACEHOLDER")}
                        // onChange={(e) =>
                        //   handleFormChange("supplierName", e.target.value)
                        // }
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/[^a-zA-Z\s.\-()]/g, "");
                          value = value.replace(/ {2,}/g, " ");
                          handleFormChange("supplierName", value)
                        }}
                        onBlur={() => {
                          const cleaned = formValues?.supplierName?.trim() || "";
                          handleFormChange("supplierName", cleaned)
                        }}
                      />
                      <label className="floating-label">
                        {t("SUPPLIER_NAME_LABEL")}
                        <span>*</span>
                      </label>
                    </Form.Item>
                    <Form.Item
                      name="supplierType"
                      className="floating-label-form-item"
                    >
                      <Select
                        className="floating-selectt"
                        placeholder="Select"
                        options={supplierTypeOptions}
                        value={formValues?.supplierType}
                        mode="single"
                        fieldNames={{
                          label: "label",
                          value: "value",
                        }}
                        name="supplierType"
                        onChange={(value) =>
                          handleFormChange("supplierType", value)
                        }
                        // disabled={ownerType}
                      />
                      <label className="floating-label">
                        {t("SUPPLIER_TYPE_SUPPLIER_LABEL")} <span>*</span>
                      </label>
                    </Form.Item>
                    {checkIsSTO(
                      addSupplierForm.getFieldValue("supplierType")
                    ) && (
                      <Form.Item
                        name="serviceType"
                        value={formValues?.serviceType}
                        rules={[
                          {
                            required: true,
                            message: t("SERVICE_TYPE_REQUIRED"),
                          },
                        ]}
                        className="floating-label-form-item"
                      >
                        <Select
                          className="floating-selectt"
                          placeholder="Select"
                          options={serviceTypesList}
                          mode="multiple"
                          value={formValues?.serviceType}
                          fieldNames={{
                            label: "serviceTypeDesc",
                            value: "serviceTypeName",
                          }}
                          onChange={(value) => {
                            console.log(value);
                            handleFormChange("serviceType", value);
                          }}
                          //style={{ width: '520px' }}
                        />
                        <label className="floating-label">
                          {t("SIGNUP_BASIC_INFO_SERVICE_TYPE")}{" "}
                          <b className="mandate-color">*</b>
                        </label>
                      </Form.Item>
                    )}

                    <Form.Item
                      name="emailId"
                      className="floating-label-form-item"
                      rules={[
                        {
                          validator: validateEmail("emailId"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={t("SIGNUP_BASIC_INFO_EMAIL_PH")}
                        className="floating-input-basic"
                        onChange={(e) => {
                          handleFormChange("emailId", e.target.value);
                          addSupplierForm.validateFields(["emailId"]);
                        }}
                      />
                      <label className="floating-label">
                        {t("SIGNUP_BASIC_INFO_EMAIL")}
                      </label>
                    </Form.Item>
                    <Form.Item
                      name="country"
                      className="floating-label-form-item"
                    >
                      <Select
                        className="floating-selectt"
                        options={countryOptions}
                        showSearch
                        placeholder={t("SIGNUP_BASIC_INFO_ADDRESS_PH")}
                        value={addSupplierForm?.getFieldValue("country")}
                        disabled={verifyMobile}
                        fieldNames={{ label: "name", value: "name" }}
                        onChange={handleCountryChange}
                        loading={countriesListWaiter}
                        filterOption={(input, option) =>
                          option.name
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      />
                      <label className="floating-label">
                        {t("SIGNUP_BASIC_INFO_COUNTRY")} <span>*</span>
                      </label>
                    </Form.Item>
                    <Form.Item name="city" className="floating-label-form-item">
                      <Select
                        className="floating-selectt"
                        placeholder={t("SIGNUP_BASIC_INFO_ADDRESS_PH")}
                        showSearch
                        options={cityOptions}
                        value={formValues?.city}
                        fieldNames={{
                          label: "name",
                          value: "name",
                        }}
                        loading={cityOptionsWaiter}
                        onChange={(val) => handleFormChange("city", val)}
                        filterOption={(input, option) =>
                          option.name
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      />
                      <label className="floating-label">
                        {t("SIGNUP_BASIC_INFO_CITY")}
                      </label>
                    </Form.Item>
                    <Form.Item
                      name="address"
                      className="floating-label-form-item"
                    >
                      <Placepicker
                        className="floating-selectt"
                        name="address"
                        showSearch
                        defaultAdd={addressDetail.address}
                        onChange={handleLocationChange}
                        defaultLocation={{
                          lat: addressDetail.latitude,
                          lng: addressDetail.longitude,
                        }}
                        value={formValues?.address}
                      />
                      <label className="floating-label">
                        {t("SIGNUP_BASIC_INFO_ADDRESS")}
                      </label>
                    </Form.Item>
                  </div>
                ) : (
                  // // *******  STEP 1 **************
                  <div>
                    {!supplierExist ? (
                      <Row className="truck-form-items-mobile">
                        <Col span={5} style={{ paddingRight: "8px" }}>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: t("COUNTRY_CODE_REQUIRED"),
                              },
                            ]}
                            name="countryCode"
                            className="floating-label-form-item"
                          >
                            <Select
                              showSearch
                              className="floating-selectt country-code-select"
                              popupClassName="country-code-popup"
                              placeholder={t("COUNTRY_CODE_LBL")}
                              fieldNames={{
                                label: "label",
                                value: "phone_code",
                              }}
                              loading={mobileCountryCodeLoader}
                              value={addSupplierForm?.getFieldValue(
                                "countryCode"
                              )}
                              options={mobileCountryCodeList.map((item) => ({
                                ...item,
                                key: `${item.phone_code}-${
                                  item.country_code
                                }-${item.name.replace(/\s+/g, "")}`, // Unique key
                              }))}
                              onChange={(value, option) => {
                                setCountryCodeName(option?.country_code);
                                handleFormChange("countryCode", value, option);
                                //addSupplierForm.setFieldValue("country", option.name);
                              }}
                              filterOption={(input, option) =>
                                option?.searchKey?.includes(input.toLowerCase())
                              }
                            />
                            <label className="floating-label">
                              {t("COUNTRY_CODE_LBL")} <span>*</span>
                            </label>
                          </Form.Item>
                        </Col>
                        <Col span={19}>
                          <Form.Item
                            name="mobileNumber"
                            className="floating-label-form-item"
                            rules={[
                              {
                                required: true,
                                message: t("MOBILE_NO_REQUIRED"),
                              },
                              {
                                pattern: /^[0-9]*$/,
                                message: t("MOBILE_NO_VALIDATION_REQUIRED"),
                              },
                              {
                                validator: (rule, value) =>
                                  validateMobileNumber(
                                    formValues?.countryCode,
                                    value,
                                    t
                                  ),
                              },
                            ]}
                          >
                            <Input
                              style={{ width: "100%" }}
                              className="floating-input"
                              name="mobileNumber"
                              placeholder={t("ENTER_MOBILE_NO_COMMON")}
                              onChange={(e) =>
                                handleFormChange("mobileNumber", e.target.value)
                              }
                              minLength={minMaxMobileNoLength.minLength}
                              maxLength={minMaxMobileNoLength.maxLength}
                            />
                            <label className="floating-label">
                              {t("FLEET_DRIVER_MOBILE_NO")}
                              <span>*</span>
                            </label>
                          </Form.Item>
                        </Col>
                      </Row>
                    ) : (
                      <>
                        {" "}
                        <div className="exist-content">
                          <img src={ExistsImg} alt="" />
                          <span>{t("SUPPLIER_SAME_NO_EXIST_MSG")}?</span>
                        </div>
                        <div className="button-row">
                          <Button
                            type="secondary"
                            className="cancel-btn"
                            onClick={() => {
                              setIsOpen(false);
                              setSupplierExist(true);
                            }}
                          >
                            {addFleet
                              ? "Try Another Driver"
                              : t("COMMON_NO_BTN")}
                          </Button>
                          <Button
                            type="secondary"
                            loading={btnLoader}
                            className="submit-btn"
                            onClick={() => addExistingSupplierFunction(null)}
                          >
                            {t("COMMON_YES_BTN")}
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                )}
                {
                  // !supplierExist &&
                  !supplierExist && !isOcrFileUpload && (
                    <Form.Item className="btn-line">
                      <Button
                        type="secondary"
                        className="cancel-btn"
                        onClick={() => {
                          onClose();
                        }}
                      >
                        {nextBtn
                          ? t("COMMON_CANCEL_BTN")
                          : t("COMMON_CANCEL_BTN")}
                      </Button>
                      <Button
                        type="secondary"
                        loading={btnLoader}
                        className="submit-btn"
                        onClick={onSubmitHandler}
                      >
                        {formType === "editForm"
                          ? "Save"
                          : nextBtnTwo
                          ? "Add Supplier KYC"
                          : nextBtn
                          ? t("ADD_SUPPLIER_COMMON")
                          : t("SIGNUP_BASIC_INFO_VERIFY_BTN")}
                        {/* {formType === "editForm" ? "Save" : nextBtnTwo ? 'Add Supplier KYC' :nextBtn ? 'Add Supplier':supplierExist ? "ok" : "Verify"} */}
                      </Button>
                    </Form.Item>
                  )
                }

                {isOcrFileUpload && ownerType && (
                  <Row
                    justify="center"
                    gutter={8}
                    style={{
                      width: "100%",
                      bottom: 0,
                      position: "sticky",
                      zIndex: 2,
                    }}
                  >
                    <Col span={12}>
                      <Button
                        style={{ width: "100%", margin: "0px" }}
                        size="large"
                        className="skip-button"
                        onClick={() => {
                          onSkipSectionChange();
                        }}
                      >
                        Skip
                      </Button>
                    </Col>

                    {ocrConfirmedFiles.length === 0 ? (
                      <Col span={12}>
                        <Button
                          style={{ width: "100%", margin: "0px" }}
                          size="large"
                          className="enter-button"
                          onClick={onClickProceed}
                        >
                          Proceed
                        </Button>
                      </Col>
                    ) : (
                      <Col span={12}>
                        <Button
                          style={{ width: "100%", margin: "0px" }}
                          size="large"
                          className="enter-button"
                          onClick={onClickSubmit}
                        >
                          Submit
                        </Button>
                      </Col>
                    )}
                  </Row>
                )}
              </Form>
            )}

            {supplierTypeSelected === "existing" && (
              <>
                <ExistingSupplierSearchList
                  setSupplierId={setSupplierId}
                  handleAddCardExisting={addExistingSupplierFunction}
                  onAddSupplierClick={() => setSupplierTypeSelected("new")}
                  // handleAddCardExisting={checkSupplierExistence}
                />
              </>
            )}

            {/* INTIAL ADD SCREEN FOR NEW AND EXISTING BUTTONS */}
            {!supplierTypeSelected && (
              <Row gutter={[8, 8]}>
                <Col span={24}>
                  <Card
                    className="add-supplier-card"
                    hoverable
                    onClick={() => setSupplierTypeSelected("existing")}
                  >
                    <Row align="middle" justify="space-between">
                      <Text className="header">Existing Supplier</Text>
                      <img
                        src={CircleArrowRight}
                        alt="Right Arrow Icon Circular"
                      />
                    </Row>
                  </Card>
                </Col>
                <Col span={24}>
                  <Card
                    className="add-supplier-card"
                    hoverable
                    onClick={() => setSupplierTypeSelected("new")}
                  >
                    <Row align="middle" justify="space-between">
                      <Text className="header">New Supplier</Text>
                      <img
                        src={CircleArrowRight}
                        alt="Right Arrow Icon Circular"
                      />
                    </Row>
                  </Card>
                </Col>
              </Row>
            )}
          </div>
        ) : (
          <div className="addfleet-detail">
            <Row gutter={16}>
              <Col span={12} style={{ height: "100%" }}>
                <Card
                  style={{ height: "100%" }}
                  title={
                    <div className="card-title">
                      {t("FLEET_DRIVER_BASIC_INFORMATION")}
                    </div>
                  }
                >
                  <div className="img-div">
                    <img src={DriverGruardImg} alt="Truck" />
                  </div>
                  <div className="details-rows">
                    <Row gutter={[8, 8]} className="data-row">
                      <div>
                        <span>{t("FLEET_DRIVER_NAME")}</span>
                        <br />
                        <span>
                          {accountDetails?.name ? accountDetails?.name : "NA"}
                        </span>
                      </div>
                      <div>
                        <span>{t("FLEET_DRIVER_MOBILE_NO")}</span> <br />
                        <span>
                          {accountDetails?.mobileNo
                            ? accountDetails?.mobileNo
                            : "NA"}
                        </span>
                      </div>
                      <div>
                        <span>{t("FLEET_DRIVER_STATUS")}</span>
                        <br />
                        <span>
                          {accountDetails?.status
                            ? accountDetails?.status
                            : "NA"}
                        </span>
                      </div>
                    </Row>
                  </div>
                </Card>
              </Col>

              <Col span={12} style={{ height: "100%" }}>
                <Card
                  title={
                    <div className="card-title">
                      {t("FLEET_TRUCKS_UPLOADED_DOC")}
                    </div>
                  }
                >
                  <div
                    style={{ overflowY: "scroll", overflowX: "hidden" }}
                    className="doc-data"
                  >
                    {/* {driverDocs && driverDocs?.map((item)=>(  */}
                    {checkIsFleetOwnerOrBroker(user?.userRole) && (
                      <div style={{ padding: "0 8px" }}>
                        <Row gutter={16} className="data-row">
                          ssdd
                          <Col span={9}>
                            {/* <span className="trucks-span">{item.type}</span> */}
                            <span>{t("VAT_CERTIFICATE_COMMON")}</span>
                          </Col>
                          <Col span={24} className="doc-file">
                            <Row justify={"end"}>
                              <img
                                style={{ height: "5rem", width: "6vw" }}
                                src={
                                  driverDocs
                                    ? driverDocs?.vatCertificate?.frontDoc
                                        ?.documentPath
                                    : ""
                                }
                                alt="alt"
                              />
                              <img
                                style={{ height: "5rem" }}
                                src={ExistsImg}
                              ></img>
                              {/* } */}
                            </Row>
                          </Col>
                        </Row>
                        <Row gutter={16} className="data-row">
                          <div>
                            <span>{t("NUMBER_COMMON")}</span>
                            {/* <span>{item?.documentNumber ? item?.documentNumber : "NA"}</span> */}
                          </div>
                          <div>
                            <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span>
                            {/* <span>{item?.expiryDate ? moment(item?.expiryDate).format(format) : "NA"}</span> */}
                          </div>
                        </Row>
                        <div className="bottom-border"></div>
                      </div>
                    )}

                    {(checkIsFleetOwner(accountDetails?.userRole) ||
                      checkIsFleetOwnerConverted(accountDetails?.userRole)) && (
                      <>
                        {!isTurkeyKazakhstanPresent ? (
                          <>
                            <div style={{ padding: "0 8px" }}>
                              <Row gutter={16} className="data-row">
                                <Col span={9}>
                                  <span>{t("VAT_CERTIFICATE_KEY")}</span>
                                </Col>
                                <Col span={15} className="doc-file">
                                  {/* <Row  justify={'end'}>
                                            
                                                <img style={{height:'5rem', width:'6vw'}} src={driverDocs ? driverDocs?.vatCertificate?.frontDoc?.documentPath : ""} alt="alt" />
                                            <img style={{height:'5rem'}}  src={driverDocs ? driverDocs?.vatCertificate?.backDoc?.documentPath : "" } ></img>
                                            </Row> */}

                                  <Row justify={"end"} gutter={[16, 16]}>
                                    {driverDocs?.vatCertificate?.frontDoc
                                      ?.documentPath && (
                                      <Col span={24}>
                                        <Fileupload
                                          accessFile={true}
                                          defaultThumbFile={
                                            driverDocs?.vatCertificate?.frontDoc
                                              ?.documentPath || ""
                                          }
                                          defaultFile={
                                            driverDocs?.vatCertificate?.frontDoc
                                              ?.documentPath || ""
                                          }
                                          readonly={true}
                                        ></Fileupload>
                                      </Col>
                                    )}
                                    <Col span={24}>
                                      {driverDocs?.vatCertificate?.backDoc
                                        ?.documentPath && (
                                        <Fileupload
                                          entityId={""}
                                          defaultThumbFile={
                                            driverDocs
                                              ? driverDocs?.vatCertificate
                                                  ?.backDoc?.documentPath
                                              : ""
                                          }
                                          defaultFile={
                                            driverDocs
                                              ? driverDocs?.vatCertificate
                                                  ?.backDoc?.documentPath
                                              : ""
                                          }
                                          readonly={true}
                                          accessFile={true}
                                        ></Fileupload>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>{" "}
                              <br />
                              <Row gutter={16} className="data-row">
                                <div>
                                  <span>{t("NUMBER_COMMON")}</span>
                                  <br />
                                  <span>
                                    {driverDocs
                                      ? driverDocs?.vatCertificate
                                          ?.documentNumber
                                      : "NA"}
                                  </span>
                                </div>
                                <div>
                                  <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span>{" "}
                                  <br />
                                  <span>
                                    {driverDocs?.vatCertificate?.expiryDate
                                      ? moment(
                                          driverDocs?.vatCertificate?.expiryDate
                                        ).format(format)
                                      : "NA"}
                                  </span>
                                </div>
                              </Row>
                              <div className="bottom-border"></div>
                            </div>

                            <div style={{ padding: "0 8px" }}>
                              <Row gutter={16} className="data-row">
                                <Col span={9}>
                                  <span>{t("ACCOUNT_TRADE_LICENSE")}</span>
                                </Col>
                                <Col span={15} className="doc-file">
                                  <Row justify={"end"} gutter={[16, 16]}>
                                    {driverDocs?.tradeLicense?.frontDoc
                                      ?.documentPath && (
                                      <Col span={24}>
                                        <Fileupload
                                          accessFile={true}
                                          defaultThumbFile={
                                            driverDocs?.tradeLicense?.frontDoc
                                              ?.documentPath || ""
                                          }
                                          defaultFile={
                                            driverDocs?.tradeLicense?.frontDoc
                                              ?.documentPath || ""
                                          }
                                          readonly={true}
                                        ></Fileupload>
                                      </Col>
                                    )}
                                    <Col span={24}>
                                      {driverDocs?.tradeLicense?.backDoc
                                        ?.documentPath && (
                                        <Fileupload
                                          entityId={""}
                                          defaultThumbFile={
                                            driverDocs
                                              ? driverDocs?.tradeLicense
                                                  ?.backDoc?.documentPath
                                              : ""
                                          }
                                          defaultFile={
                                            driverDocs
                                              ? driverDocs?.tradeLicense
                                                  ?.backDoc?.documentPath
                                              : ""
                                          }
                                          readonly={true}
                                          accessFile={true}
                                        ></Fileupload>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="data-row">
                                <div>
                                  <span>{t("NUMBER_COMMON")}</span>
                                  <br />
                                  <span>
                                    {driverDocs
                                      ? driverDocs?.tradeLicense?.documentNumber
                                      : "NA"}
                                  </span>
                                </div>
                                <div>
                                  <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span>{" "}
                                  <br />
                                  <span>
                                    {driverDocs?.tradeLicense?.expiryDate
                                      ? moment(
                                          driverDocs?.tradeLicense?.expiryDate
                                        ).format(format)
                                      : "NA"}
                                  </span>
                                </div>
                              </Row>
                              <div className="bottom-border"></div>
                            </div>
                          </>
                        ) : // iban
                        accountDetails?.operatingCountry === "Kazakhstan" ? (
                          <>
                            <div style={{ padding: "0 8px" }}>
                              <Row gutter={16} className="data-row">
                                <Col span={9}>
                                  <span>{t("VAT_CERTIFICATE_COMMON")}</span>
                                </Col>
                                <Col span={15} className="doc-file">
                                  <Row justify={"end"} gutter={[16, 16]}>
                                    {driverDocs?.tradeLicense?.frontDoc
                                      ?.documentPath && (
                                      <Col span={24}>
                                        <Fileupload
                                          accessFile={true}
                                          defaultThumbFile={
                                            driverDocs?.tradeLicense?.frontDoc
                                              ?.documentPath || ""
                                          }
                                          defaultFile={
                                            driverDocs?.tradeLicense?.frontDoc
                                              ?.documentPath || ""
                                          }
                                          readonly={true}
                                        ></Fileupload>
                                      </Col>
                                    )}
                                    <Col span={24}>
                                      {driverDocs?.tradeLicense?.backDoc
                                        ?.documentPath && (
                                        <Fileupload
                                          entityId={""}
                                          defaultThumbFile={
                                            driverDocs
                                              ? driverDocs?.tradeLicense
                                                  ?.backDoc?.documentPath
                                              : ""
                                          }
                                          defaultFile={
                                            driverDocs
                                              ? driverDocs?.tradeLicense
                                                  ?.backDoc?.documentPath
                                              : ""
                                          }
                                          readonly={true}
                                          accessFile={true}
                                        ></Fileupload>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>{" "}
                              <br />
                              <Row gutter={16} className="data-row">
                                <div>
                                  <span>{t("NUMBER_KEY")}</span>
                                  <br />
                                  <span>
                                    {driverDocs
                                      ? driverDocs?.tradeLicense?.documentNumber
                                      : "NA"}
                                  </span>
                                </div>
                                <div>
                                  <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span>{" "}
                                  <br />
                                  <span>
                                    {driverDocs?.tradeLicense?.expiryDate
                                      ? moment(
                                          driverDocs?.tradeLicense?.expiryDate
                                        ).format(format)
                                      : "NA"}
                                  </span>
                                </div>
                              </Row>
                              <div className="bottom-border"></div>
                            </div>
                            <div>
                              <span>{t("ACCOUNT_IBAN_NO")}</span>
                              <br />
                              <br />
                              {driverDocs?.iBanNo.map((iban, index) => (
                                <div key={index}>{iban}</div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <>
                            <div>
                              <Row gutter={16} className="data-row">
                                <Col span={9}>
                                  <span>{t("VAT_CERTIFICATE_COMMON")}</span>
                                </Col>
                                <Col span={15} className="doc-file">
                                  <Row justify={"end"} gutter={[16, 16]}>
                                    {driverDocs?.vatCertificate?.frontDoc
                                      ?.documentPath && (
                                      <Col span={24}>
                                        <Fileupload
                                          accessFile={true}
                                          defaultThumbFile={
                                            driverDocs?.vatCertificate?.frontDoc
                                              ?.documentPath || ""
                                          }
                                          defaultFile={
                                            driverDocs?.vatCertificate?.frontDoc
                                              ?.documentPath || ""
                                          }
                                          readonly={true}
                                        ></Fileupload>
                                      </Col>
                                    )}
                                    <Col span={24}>
                                      {driverDocs?.vatCertificate?.backDoc
                                        ?.documentPath && (
                                        <Fileupload
                                          entityId={""}
                                          defaultThumbFile={
                                            driverDocs
                                              ? driverDocs?.vatCertificate
                                                  ?.backDoc?.documentPath
                                              : ""
                                          }
                                          defaultFile={
                                            driverDocs
                                              ? driverDocs?.vatCertificate
                                                  ?.backDoc?.documentPath
                                              : ""
                                          }
                                          readonly={true}
                                          accessFile={true}
                                        ></Fileupload>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>{" "}
                              <br />
                              <Row className="data-row">
                                <div>
                                  <span>{t("NUMBER_COMMON")}</span>
                                  <br />
                                  <span>
                                    {driverDocs
                                      ? driverDocs?.vatCertificate
                                          ?.documentNumber
                                      : "NA"}
                                  </span>
                                </div>
                                <div>
                                  <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span>{" "}
                                  <br />
                                  <span>
                                    {driverDocs?.vatCertificate?.expiryDate
                                      ? moment(
                                          driverDocs?.vatCertificate?.expiryDate
                                        ).format(format)
                                      : "NA"}
                                  </span>
                                </div>
                              </Row>
                              <div className="bottom-border"></div>
                            </div>
                            <div>
                              <span>{t("ACCOUNT_IBAN_NO")}</span>
                              <br />
                              <br />
                              {driverDocs?.iBanNo.map((iban, index) => (
                                <div key={index}>{iban}</div>
                              ))}
                            </div>
                          </>
                        )}
                      </>
                    )}

                    {checkIsSTOorBroker(accountDetails?.userRole) && (
                      <>
                        <div>
                          <Row gutter={16} className="data-row">
                            <Col span={9}>
                              <span>{t("SIGNUP_KYC_DRIVING_LIC_HEADER")}</span>
                            </Col>
                            <Col span={15} className="doc-file">
                              <Row justify={"end"} gutter={[16, 16]}>
                                {driverDocs?.drivingLicense?.frontDoc
                                  ?.documentPath && (
                                  <Col span={24}>
                                    <Fileupload
                                      accessFile={true}
                                      defaultThumbFile={
                                        driverDocs?.drivingLicense?.frontDoc
                                          ?.documentPath || ""
                                      }
                                      defaultFile={
                                        driverDocs?.drivingLicense?.frontDoc
                                          ?.documentPath || ""
                                      }
                                      readonly={true}
                                    ></Fileupload>
                                  </Col>
                                )}
                                <Col span={24}>
                                  {driverDocs?.drivingLicense?.backDoc
                                    ?.documentPath && (
                                    <Fileupload
                                      entityId={""}
                                      defaultThumbFile={
                                        driverDocs
                                          ? driverDocs?.drivingLicense?.backDoc
                                              ?.documentPath
                                          : ""
                                      }
                                      defaultFile={
                                        driverDocs
                                          ? driverDocs?.drivingLicense?.backDoc
                                              ?.documentPath
                                          : ""
                                      }
                                      readonly={true}
                                      accessFile={true}
                                    ></Fileupload>
                                  )}
                                </Col>

                                {/* <img style={{height:'5rem', width:'6vw'}} src={driverDocs && driverDocs?.drivingLicense?.frontDoc?.documentPath } />
                                    <img style={{height:'5rem'}}  src={driverDocs ? driverDocs?.drivingLicense?.backDoc?.documentPath : "" } ></img> */}
                              </Row>
                            </Col>
                          </Row>{" "}
                          <br />
                          <Row className="data-row">
                            <div>
                              <span>
                                {t("FLEET_DRIVER_DRIVING_LICENSE_NO")}
                              </span>
                              <br />
                              <span>
                                {driverDocs
                                  ? driverDocs?.drivingLicense?.documentNumber
                                  : "NA"}
                              </span>
                            </div>
                            <div>
                              <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span>{" "}
                              <br />
                              <span>
                                {driverDocs?.drivingLicense?.expiryDate
                                  ? moment(
                                      driverDocs?.drivingLicense?.expiryDate
                                    ).format(format)
                                  : "NA"}
                              </span>
                            </div>
                          </Row>
                          <div className="bottom-border"></div>
                        </div>

                        <div>
                          <Row gutter={16} className="data-row">
                            <Col span={9}>
                              <span>{t("FLEET_DRIVER_PASSPORT")}</span>
                            </Col>
                            <Col span={15} className="doc-file">
                              {/* <Row  justify={'end'}>
                                    
                                        <img style={{height:'5rem', width:'6vw'}} src={driverDocs ? driverDocs?.passport?.frontDoc?.documentPath : ""} />
                                    <img style={{height:'5rem'}}  src={driverDocs ? driverDocs?.passport?.backDoc?.documentPath : "" } ></img>
                                    </Row> */}
                              <Row justify={"end"} gutter={[16, 16]}>
                                {driverDocs?.passport?.frontDoc
                                  ?.documentPath && (
                                  <Col span={24}>
                                    <Fileupload
                                      accessFile={true}
                                      defaultThumbFile={
                                        driverDocs?.passport?.frontDoc
                                          ?.documentPath || ""
                                      }
                                      defaultFile={
                                        driverDocs?.passport?.frontDoc
                                          ?.documentPath || ""
                                      }
                                      readonly={true}
                                    ></Fileupload>
                                  </Col>
                                )}
                                <Col span={24}>
                                  {driverDocs?.passport?.backDoc
                                    ?.documentPath && (
                                    <Fileupload
                                      entityId={""}
                                      defaultThumbFile={
                                        driverDocs
                                          ? driverDocs?.passport?.backDoc
                                              ?.documentPath
                                          : ""
                                      }
                                      defaultFile={
                                        driverDocs
                                          ? driverDocs?.passport?.backDoc
                                              ?.documentPath
                                          : ""
                                      }
                                      readonly={true}
                                      accessFile={true}
                                    ></Fileupload>
                                  )}
                                </Col>

                                {/* <img style={{height:'5rem', width:'6vw'}} src={driverDocs && driverDocs?.drivingLicense?.frontDoc?.documentPath } />
                                    <img style={{height:'5rem'}}  src={driverDocs ? driverDocs?.drivingLicense?.backDoc?.documentPath : "" } ></img> */}
                              </Row>
                            </Col>
                          </Row>{" "}
                          <br />
                          <Row className="data-row">
                            <div>
                              <span>{t("FLEET_DRIVER_PASSPORT_NO")}</span>
                              <br />
                              <span>
                                {driverDocs
                                  ? driverDocs?.passport?.documentNumber
                                  : "NA"}
                              </span>
                            </div>
                            <div>
                              <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span>{" "}
                              <br />
                              <span>
                                {driverDocs?.drivingLicense?.expiryDate
                                  ? moment(
                                      driverDocs?.drivingLicense?.expiryDate
                                    ).format(format)
                                  : "NA"}
                              </span>
                            </div>
                          </Row>
                          <div className="bottom-border"></div>
                        </div>

                        <div>
                          <Row gutter={16} className="data-row">
                            <Col span={9}>
                              <span>{t("FLEET_DRIVER_NATIONAL_ID")}</span>
                            </Col>
                            <Col span={15} className="doc-file">
                              <Row justify={"end"} gutter={[16, 16]}>
                                {driverDocs?.nationalID?.frontDoc
                                  ?.documentPath && (
                                  <Col span={24}>
                                    <Fileupload
                                      accessFile={true}
                                      defaultThumbFile={
                                        driverDocs?.nationalID?.frontDoc
                                          ?.documentPath || ""
                                      }
                                      defaultFile={
                                        driverDocs?.nationalID?.frontDoc
                                          ?.documentPath || ""
                                      }
                                      readonly={true}
                                    ></Fileupload>
                                  </Col>
                                )}
                                <Col span={24}>
                                  {driverDocs?.nationalID?.backDoc
                                    ?.documentPath && (
                                    <Fileupload
                                      entityId={""}
                                      defaultThumbFile={
                                        driverDocs
                                          ? driverDocs?.nationalID?.backDoc
                                              ?.documentPath
                                          : ""
                                      }
                                      defaultFile={
                                        driverDocs
                                          ? driverDocs?.nationalID?.backDoc
                                              ?.documentPath
                                          : ""
                                      }
                                      readonly={true}
                                      accessFile={true}
                                    ></Fileupload>
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <br />
                          <Row className="data-row">
                            <div>
                              <span>{t("FLEET_DRIVER_NATIONAL_ID_NO")}</span>
                              <br />
                              <span>
                                {driverDocs
                                  ? driverDocs?.nationalID?.documentNumber
                                  : "NA"}
                              </span>
                            </div>
                            <div>
                              <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span>{" "}
                              <br />
                              <span>
                                {driverDocs?.nationalID?.expiryDate
                                  ? moment(
                                      driverDocs?.nationalID.expiryDate
                                    ).format(format)
                                  : "NA"}
                              </span>
                            </div>
                          </Row>
                          <div className="bottom-border"></div>
                        </div>

                        <div style={{ marginTop: "16px" }}>
                          {visaArray?.map((visa) => (
                            <>
                              <Row gutter={16} className="data-row">
                                <Col span={9}>
                                  <span>{t("FLEET_DRIVER_VISA")}</span>
                                </Col>
                                <Col span={15} className="doc-file">
                                  <Row justify={"end"}>
                                    {visa?.frontDoc?.documentPath && (
                                      <Col
                                        span={24}
                                        style={{
                                          height: "80px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <Fileupload
                                          accessFile={true}
                                          defaultThumbFile={
                                            visa?.frontDoc?.documentPath || ""
                                          }
                                          defaultFile={
                                            visa?.frontDoc?.documentPath || ""
                                          }
                                          readonly={true}
                                        ></Fileupload>
                                      </Col>
                                    )}
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="data-row">
                                <div>
                                  <span>{t("FLEET_DRIVER_VISA_NO")}</span>
                                  <br />
                                  <span>
                                    {visa ? visa?.documentNumber : "NA"}
                                  </span>
                                </div>
                                <div>
                                  <span>{t("FLEET_DRIVER_EXPIRY_DATE")}</span>{" "}
                                  <br />
                                  <span>
                                    {visa?.expiryDate
                                      ? moment(
                                          driverDocs?.passport?.expiryDate
                                        ).format(format)
                                      : "NA"}
                                  </span>
                                </div>
                              </Row>
                              <br />
                              {/* <div className="bottom-border"></div> */}
                            </>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </Card>
              </Col>
              <div
                className="modal-button-row"
                style={{ display: "flex", justifyContent: "center" }}
              >
                {addExistingSupplierModal && (
                  <>
                    <Button
                      onClick={() => setIsOpen(false)}
                      type="secondary"
                      className="cancel-btn"
                    >
                      {t("COMMON_CANCEL_BTN")}
                    </Button>
                    <Button
                      type="secondary"
                      disabled={checkIsDisabledToAddSupplier()}
                      loading={btnLoader}
                      onClick={handleAddSupplier} // ADD EXISTIG
                      className="submit-btn"
                    >
                      {t("ADD_SUPPLIER_COMMON")}
                    </Button>
                  </>
                )}
              </div>
            </Row>
          </div>
        )}
      </Modal>

      {/*  *********** Upload Document Drawer  ************ */}
      <Drawer
        className="drawer-upload"
        title={
          <>
            <div className="drawer-title">
              Upload Document
              <Button
                icon={<CloseOutlined />}
                type="text"
                onClick={() => setOpenDrawer(false)}
                style={{ fontSize: "16px" }}
              />
            </div>
          </>
        }
        onClose={() => {
          setOpenDrawer(false);
        }}
        closable={false}
        open={openDrawer}
        styles={{
          header: {
            padding: "0",
            border: "none",
          },
          body: {
            padding: "0",
            position: "relative",
          },
        }}
      >
        <>
          <div className="drawer-upload-body">
            <OCRFileUpload
              // onChange={handleFileChange}
              onChange={handleOCRConformFileChange}
              uploadedFiles={ocrConfirmedFiles}
              // onDelete={handleFileDelete}
              onDelete={handleOCRConfirmFileDelete}
            />
          </div>
          <Row
            justify="center"
            gutter={8}
            style={{
              width: "100%",
              bottom: 0,
              position: "absolute",
            }}
          >
            <Col span={12}>
              <Button
                style={{ width: "100%", margin: "0px" }}
                size="large"
                className="skip-button"
                onClick={() => setOpenDrawer(false)}
              >
                Cancel
              </Button>
            </Col>
            <Col span={12}>
              <Button
                style={{ width: "100%", margin: "0px" }}
                size="large"
                className="submit-button"
                onClick={handleDrawerFileSubmit}
                disabled={false}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </>
      </Drawer>

      {/* Document Missing Modal */}
      <Modal
        open={missingDocModal}
        footer={null}
        closable={false}
        width={400}
        // onCancel={() => setIsUploadingPopupVisible(false)}
        centered
        style={{ textAlign: "center", padding: "16px 16px 32px 16px" }}
      >
        <MissingDocModal
          onClose={() => setMissingDocModal(false)}
          handleMissingDocSubmit={() => {
            setMissingDocModal(false);
            setNextBtn(true);
            setIsOcrFileUpload(false);
          }}
          isFileUploaded={!ocrParsedData && ocrConfirmedFiles.length > 0}
        />
      </Modal>

      {/* Sample Document View Modal */}
      <Modal open={isSamplePreviewOpen} footer={null} closable={false} centered>
        <SampleDocumentPreviewModal
          sampleType={sampleType}
          countryCodeName={countryCodeName || "AE"}
          onClose={() => setSamplePreviewOpen(false)}
        />
      </Modal>

      {/* Uploading OCR Loading */}
      <Modal
        open={isUploadingPopupVisible}
        footer={null}
        closable={false}
        // onCancel={() => setIsUploadingPopupVisible(false)}
        centered
        width={352}
        style={{
          textAlign: "center",
          padding: "32px 16px",
          zIndex: "2000000 !important",
          position: "relative",
        }}
      >
        <h3
          style={{
            fontWeight: "600",
            fontSize: "18px",
            lineHeight: "1.5",
            margin: 0,
          }}
        >
          Uploading and processing documents
        </h3>
        <div style={{ margin: "12px 0" }}>
          <img
            // src={logo}
            src={fileSearchGif}
            alt="File Search"
            style={{ width: 112, height: 112 }}
          ></img>
        </div>

        <p
          style={{
            fontWeight: "500",
            fontSize: "14px",
            margin: 0,
            color: "#2C3A4BE5",
          }}
        >
          {uploadState.status}
        </p>
        <p
          style={{
            color: "#394452",
            fontSize: "12px",
            marginTop: "8px",
            marginBottom: 0,
            color: "#394452CC",
          }}
        >
          {uploadState.description}
        </p>
      </Modal>

      {/* DISCARD MODAL */}
      <DiscardWarningModal
        visible={isDiscardModalVisible}
        onOk={() => handleProceedDiscardOcrData()}
        onCancel={() => setIsDiscardModalVisible(false)}
      />
    </div>
  );
};

export default AddSupplier;
